import {
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  VOID3gxj6tk5isa35 as VOID,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  enumEntries20mr21zbe3az4 as enumEntries,
  Enum3alwj03lh1n41 as Enum,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivaggyjf2c4e0j as _Result___get_isFailure__impl__jpiriv,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  CancellationException3b36o9qz53rgr as CancellationException,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toHexString5bhtjxqec7ow as toHexString,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  emptyMapr06gerzljqtm as emptyMap,
  KtMap140uvy3s5zad8 as KtMap,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  Duration__isPositive_impl_tvkkt23p4mzdx5y5zb9 as Duration__isPositive_impl_tvkkt2,
  to2cs3ny02qtbcb as to,
  constructCallableReference23y65rf941mch as constructCallableReference,
  equals2au1ep9vhcato as equals,
  ArrayList3it5z8td81qkl as ArrayList,
  Duration__toString_impl_8d916b1rke7yypzm7mk as Duration__toString_impl_8d916b,
  lazy2hsh8ze7j6ikd as lazy,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  toMap1vec9topfei08 as toMap,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  LazyThreadSafetyMode_PUBLICATION_getInstance20ynwq7b0awd8 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toSet2orjxp16sotqu as toSet,
  minus27abgkurcn6u0 as minus,
  first58ocm7j58k3q as first,
  mutableMapOfk2y3zt1azl40 as mutableMapOf,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  split2bvyvnrlcifjv as split,
  emptyList1g2z5xcrvp2zy as emptyList,
  getOrNull1go7ef9ldk0df as getOrNull,
  removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull,
  intercepted2ogpsikxxj4u0 as intercepted,
  joinToStringxqcavsxcmh4q as joinToString_0,
  toString1h6jjoch8cjt8 as toString_1,
  toShort36kaw0zjdq3ex as toShort,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  isArray1hxjqtqy632bc as isArray,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_rpcInternalTypeNamep2np7akmmxlr as get_rpcInternalTypeName,
  internalRpcError1b617d9nu02o as internalRpcError,
  RpcTypeKrpc22kokcfex4fxr as RpcTypeKrpc,
  rpcInternalKClass35462zlbbsp1q as rpcInternalKClass,
} from './kotlinx-rpc-core.mjs';
import {
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  launch1c91vkjzdi9sd as launch,
  Mutex16li1l0asjv17 as Mutex,
  cancel2ztysw4v4hav6 as cancel,
  ChannelResult__getOrNull_impl_f5e07h2lg0qlstspu0r as ChannelResult__getOrNull_impl_f5e07h,
  delayvyed5wvki0ic as delay,
  Channel3r72atmcithql as Channel,
  get_job2zvlvce9o9a29 as get_job,
  _ChannelResult___get_isSuccess__impl__odq1z9t6ktwy0g0q0f as _ChannelResult___get_isSuccess__impl__odq1z9,
  _ChannelResult___get_isFailure__impl__nz6ehu2fj0qoa5trbx8 as _ChannelResult___get_isFailure__impl__nz6ehu,
  ChannelResult__exceptionOrNull_impl_16ei302x9fo9thjhzif as ChannelResult__exceptionOrNull_impl_16ei30,
  _ChannelResult___get_isClosed__impl__mg7kuu3a26on4apn4j4 as _ChannelResult___get_isClosed__impl__mg7kuu,
  ChannelResult__getOrThrow_impl_od1axsdky2zm58n02y as ChannelResult__getOrThrow_impl_od1axs,
  withTimeoutOrNull2qr9d4v42lp0r as withTimeoutOrNull,
  CoroutineStart_LAZY_getInstanceyyljs516jwiz as CoroutineStart_LAZY_getInstance,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  _ChannelResult___get_holder__impl__pm9gzwvud6m7n0fzs7 as _ChannelResult___get_holder__impl__pm9gzw,
  Failed2z52ugz2lqu8t as Failed,
  Closed8t4xgopf7j5r as Closed,
} from './kotlinx-coroutines-core.mjs';
import {
  StringFormat2r2ka8mzcb3mi as StringFormat,
  BinaryFormat3f3aelhmz0ro1 as BinaryFormat,
  serializer1i4e9ym37oxmo as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  StringSerializer_getInstancerxlnwnlbnwri as StringSerializer_getInstance,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  LongSerializer_getInstance1q1voa3zes72d as LongSerializer_getInstance,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  ByteArraySerializer_getInstance3p3rwnvaterxj as ByteArraySerializer_getInstance,
  SerializableWithd2dap36updxd as SerializableWith,
  SHORT_getInstance1w4976erfyxry as SHORT_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  Serializable1wyi8gijab9yh as Serializable,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  IntSerializer_getInstance3hkg1llvt1c0z as IntSerializer_getInstance,
  STRING_getInstance1ov5zayfui8fl as STRING_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  RpcInternalDumpLoggerContainer_instance19d4gfuy68062 as RpcInternalDumpLoggerContainer_instance,
  Companion_getInstance1nbjfh65ymx8 as Companion_getInstance_0,
} from './kotlinx-rpc-krpc-krpc-logging.mjs';
import { RpcInternalConcurrentHashMap298ok532k8jut as RpcInternalConcurrentHashMap } from './kotlinx-rpc-utils.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  ReentrantLock24w8gy4ird1e4 as ReentrantLock,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Connector {
  constructor() {
    this.g8o_1 = Companion_getInstance().kk_1;
    this.h8o_1 = Companion_getInstance().kk_1;
    this.i8o_1 = 1000;
  }
}
class KrpcConfigBuilder {
  constructor() {
    this.n8o_1 = true;
    this.o8o_1 = null;
    this.p8o_1 = new Connector();
    var tmp = this;
    tmp.q8o_1 = new KrpcConfigBuilder$configuration$1(this);
  }
  t8o(builder) {
    builder(this.q8o_1);
  }
  s8o() {
    return new Connector_0(this.p8o_1.g8o_1, this.p8o_1.h8o_1, this.p8o_1.i8o_1);
  }
  r8o() {
    var format = this.o8o_1;
    var tmp;
    if (format == null) {
      // Inline function 'kotlin.error' call
      var message = 'Please, choose serialization format';
      throw IllegalStateException.o(toString(message));
    } else {
      tmp = format;
    }
    return tmp;
  }
}
class Client extends KrpcConfigBuilder {
  j7e() {
    return new Client_0(this.r8o(), this.s8o());
  }
}
class KrpcConfigBuilder$configuration$1 {
  constructor(this$0) {
    this.u8o_1 = this$0;
  }
  v8o(rpcSerialFormatInitializer) {
    this.u8o_1.o8o_1 = rpcSerialFormatInitializer;
  }
}
class Connector_0 {
  constructor(waitTimeout, callTimeout, perCallBufferSize) {
    this.w8o_1 = waitTimeout;
    this.x8o_1 = callTimeout;
    this.y8o_1 = perCallBufferSize;
    // Inline function 'kotlin.require' call
    if (!!(this.y8o_1 === 0)) {
      var message = 'perCallBufferSize must not be zero';
      throw IllegalArgumentException.h2(toString(message));
    }
  }
}
class Client_0 {
  constructor(serialFormatInitializer, connector) {
    this.z8o_1 = serialFormatInitializer;
    this.a8p_1 = connector;
  }
}
class StringMessage {
  constructor(value) {
    this.b8p_1 = value;
  }
}
class BinaryMessage {
  constructor(value) {
    this.c8p_1 = value;
  }
}
class Success {
  constructor(message) {
    this.e8p_1 = message;
  }
}
class Failure {}
class Closed_0 {
  constructor(cause) {
    this.f8p_1 = cause;
  }
}
class Companion {
  g8p(value) {
    // Inline function 'kotlin.collections.find' call
    var tmp0 = get_entries();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.v1_1 === value) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
}
class RpcInternalIndexedEnum {}
class CancellationType extends Enum {
  constructor(name, ordinal, uniqueIndex) {
    super(name, ordinal);
    this.j8p_1 = uniqueIndex;
  }
  k8p() {
    return this.j8p_1;
  }
}
class Companion_0 {
  constructor() {
    this.g8r_1 = 'Send';
    this.h8r_1 = 'Receive';
    this.i8r_1 = 'Server';
    this.j8r_1 = 'Client';
  }
}
class KrpcConnector {
  constructor(serialFormat, transport, config, isServer) {
    this.q8p_1 = serialFormat;
    this.r8p_1 = transport;
    this.s8p_1 = config;
    this.t8p_1 = this.r8p_1;
    this.u8p_1 = isServer ? 'Server' : 'Client';
    this.v8p_1 = Companion_getInstance_0().c8m(this.u8p_1 + ' Connector');
    this.w8p_1 = RpcInternalConcurrentHashMap();
    this.x8p_1 = RpcInternalConcurrentHashMap();
    this.y8p_1 = RpcInternalConcurrentHashMap();
    this.z8p_1 = RpcInternalConcurrentHashMap();
    this.a8q_1 = Channel(2147483647);
    this.b8q_1 = null;
    this.c8q_1 = null;
    this.d8q_1 = false;
    var tmp = this;
    tmp.e8q_1 = lazy(KrpcConnector$dumpLogger$delegate$lambda);
    var tmp_0 = this;
    var tmp_1 = CoroutineName.b1u('krpc-connector-send-loop');
    tmp_0.f8q_1 = launch(this.t8p_1, tmp_1, VOID, KrpcConnector$slambda(this));
    var tmp_2 = CoroutineName.b1u('krpc-connector-receive-loop');
    launch(this.t8p_1, tmp_2, VOID, KrpcConnector$slambda_0(this));
    var tmp_3 = get_job(this.t8p_1.d1m());
    tmp_3.g1n(KrpcConnector$lambda(this));
  }
  r8r() {
    return this.t8p_1;
  }
  *g8q(message, $completion) {
    if (message instanceof Handshake) {
      var tmp0 = message.y8q_1;
      var tmp2 = KrpcPluginKey_WINDOW_UPDATE_getInstance();
      // Inline function 'kotlin.collections.set' call
      var value = '' + this.s8p_1.y8o_1;
      tmp0.b5(tmp2, value);
    }
    var tmp0_subject = this.q8p_1;
    var tmp;
    if (isInterface(tmp0_subject, StringFormat)) {
      // Inline function 'kotlinx.serialization.encodeToString' call
      var this_0 = this.q8p_1;
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.l10();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(KrpcMessage), arrayOf([]), false));
      var tmp$ret$2 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      var tmp$ret$1 = this_0.m10(tmp$ret$2, message);
      tmp = new StringMessage(tmp$ret$1);
    } else {
      if (isInterface(tmp0_subject, BinaryFormat)) {
        // Inline function 'kotlinx.serialization.encodeToByteArray' call
        var this_3 = this.q8p_1;
        // Inline function 'kotlinx.serialization.serializer' call
        var this_4 = this_3.l10();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_5 = serializer(this_4, createKType(getKClass(KrpcMessage), arrayOf([]), false));
        var tmp$ret$5 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
        var tmp$ret$4 = this_3.j10(tmp$ret$5, message);
        tmp = new BinaryMessage(tmp$ret$4);
      } else {
        unsupportedSerialFormatError(this.q8p_1);
      }
    }
    var transportMessage = tmp;
    if (_get_dumpLogger__tc8cbr(this).c8n()) {
      var tmp_0 = _get_dumpLogger__tc8cbr(this);
      tmp_0.e8n([this.u8p_1, 'Send'], KrpcConnector$sendMessage$lambda(transportMessage));
    }
    yield* /*#__NOINLINE__*/sendTransportMessage(this, handlerKey(message), transportMessage, $completion);
    return Unit_instance;
  }
  *s8r(key, $completion) {
    // Inline function 'kotlinx.rpc.krpc.internal.KrpcConnector.withLockForKey' call
    var tmp;
    var tmp_0;
    if (key instanceof ServiceCall) {
      tmp_0 = this.u8p_1 === 'Server';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new Service(key.z8q_1);
    } else {
      tmp = key;
    }
    var lockKey = tmp;
    var tmp_1;
    if (false) {
      tmp_1 = this.x8p_1.g8l(lockKey, KrpcConnector$unsubscribeFromMessages$lambda);
    } else {
      tmp_1 = this.x8p_1.r7c(lockKey);
    }
    var mutex = tmp_1;
    var tmp_2;
    if (mutex == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      yield* mutex.y2a(null, $completion);
      var tmp_3;
      try {
        var tmp_4;
        if (key instanceof Service) {
          this.w8p_1.j8l(KrpcConnector$unsubscribeFromMessages$lambda_0(key, this));
          tmp_4 = this.y8p_1.h8l(key);
        } else {
          cleanForKey(this, key);
          tmp_4 = Unit_instance;
        }
        tmp_3 = tmp_4;
      }finally {
        mutex.k2a(null);
      }
      tmp_2 = tmp_3;
    }
    return Unit_instance;
  }
  *t8r(key, subscription, $completion) {
    // Inline function 'kotlinx.rpc.krpc.internal.KrpcConnector.withLockForKey' call
    var tmp;
    var tmp_0;
    if (key instanceof ServiceCall) {
      tmp_0 = this.u8p_1 === 'Server';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new Service(key.z8q_1);
    } else {
      tmp = key;
    }
    var lockKey = tmp;
    var tmp_1;
    if (true) {
      tmp_1 = this.x8p_1.g8l(lockKey, KrpcConnector$subscribeToMessages$lambda);
    } else {
      tmp_1 = this.x8p_1.r7c(lockKey);
    }
    var mutex = tmp_1;
    var tmp_2;
    if (mutex == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      yield* mutex.y2a(null, $completion);
      var tmp_3;
      try {
        if (key instanceof Service) {
          this.y8p_1.g8l(key, KrpcConnector$subscribeToMessages$lambda_0(subscription));
          this.w8p_1.j8l(KrpcConnector$subscribeToMessages$lambda_1(key, this, subscription));
        } else {
          subscribeWithActingHandlerPerTrack(this, key, subscription);
        }
        tmp_3 = Unit_instance;
      }finally {
        mutex.k2a(null);
      }
      tmp_2 = tmp_3;
    }
    return Unit_instance;
  }
  u8r(message) {
    this.a8q_1.y22();
    this.f8q_1.g1n(KrpcConnector$drainSendQueueAndClose$lambda(this, message));
  }
}
class KrpcEndpoint {}
function sendCancellation(type, serviceId, cancellationId, closeTransportAfterSending) {
  if (!this.w8r().w2(KrpcPlugin_CANCELLATION_getInstance())) {
    if (closeTransportAfterSending) {
      this.v8r().u8r('Transport finished');
    }
    return Unit_instance;
  }
  var tmp = this.v8r().r8r();
  var tmp_0 = CoroutineName.b1u('krpc-endpoint-cancellation-' + serviceId + '-' + cancellationId);
  var sendJob = launch(tmp, tmp_0, VOID, KrpcEndpoint$sendCancellation$slambda(type, serviceId, cancellationId, this));
  if (closeTransportAfterSending) {
    sendJob.g1n(KrpcEndpoint$sendCancellation$lambda(this));
  }
}
function sendCancellation$default(type, serviceId, cancellationId, closeTransportAfterSending, $super) {
  closeTransportAfterSending = closeTransportAfterSending === VOID ? false : closeTransportAfterSending;
  var tmp;
  if ($super === VOID) {
    this.x8r(type, serviceId, cancellationId, closeTransportAfterSending);
    tmp = Unit_instance;
  } else {
    sendCancellation(type, serviceId, cancellationId, closeTransportAfterSending);
    tmp = Unit_instance;
  }
  return tmp;
}
function *handleGenericMessage(message, $completion) {
  try {
    var tmp0_safe_receiver = message.r8q_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(KrpcPluginKey_GENERIC_MESSAGE_TYPE_getInstance())) === 'cancellation') {
      yield* this.a8s(message, $completion);
    }
  } catch ($p) {
    if ($p instanceof IllegalStateException) {
      var e = $p;
      var tmp2_elvis_lhs = e.message;
      var failure = new Failure_0(tmp2_elvis_lhs == null ? 'Unknown error' : tmp2_elvis_lhs, message.q8q_1);
      // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
      var this_0 = this.v8r();
      try {
        yield* this_0.g8q(failure, $completion);
      } catch ($p_0) {
        if ($p_0 instanceof ClosedSendChannelException) {
          var e_0 = $p_0;
        } else {
          throw $p_0;
        }
      }
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d8s_1 = [null, lazy_0(tmp_0, KrpcGenericMessage$Companion$$childSerializers$_anonymous__9d8z7k)];
    this.e8s_1 = 'cancellation';
  }
}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.internal.transport.RPCGenericMessage', this, 2);
    tmp0_serialDesc.h1b('connectionId', false);
    tmp0_serialDesc.h1b('pluginParams', false);
    this.f8s_1 = tmp0_serialDesc;
  }
  g8s(encoder, value) {
    var tmp0_desc = this.f8s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().d8s_1;
    tmp1_output.i15(tmp0_desc, 0, LongSerializer_getInstance(), value.q8q_1);
    tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.r8q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g8s(encoder, value instanceof KrpcGenericMessage ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f8s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_3().d8s_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.d14(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.d14(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return KrpcGenericMessage.h8s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f8s_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_3().d8s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[1].k3())];
  }
}
class KrpcMessage {}
class KrpcGenericMessage {
  constructor(connectionId, pluginParams) {
    Companion_getInstance_3();
    this.q8q_1 = connectionId;
    this.r8q_1 = pluginParams;
  }
  c8r() {
    return this.q8q_1;
  }
  i8s() {
    return this.r8q_1;
  }
  toString() {
    return 'KrpcGenericMessage(connectionId=' + toString_0(this.q8q_1) + ', pluginParams=' + toString_0(this.r8q_1) + ')';
  }
  hashCode() {
    var result = this.q8q_1 == null ? 0 : this.q8q_1.hashCode();
    result = imul(result, 31) + (this.r8q_1 == null ? 0 : hashCode(this.r8q_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KrpcGenericMessage))
      return false;
    if (!equals(this.q8q_1, other.q8q_1))
      return false;
    if (!equals(this.r8q_1, other.r8q_1))
      return false;
    return true;
  }
  static h8s(seen0, connectionId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_3();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance().f8s_1);
    }
    var $this = createThis(this);
    $this.q8q_1 = connectionId;
    $this.r8q_1 = pluginParams;
    return $this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, KrpcProtocolMessage$Handshake$Companion$$childSerializers$_anonymous__75pzc2);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l8s_1 = [tmp_1, null, lazy_0(tmp_2, KrpcProtocolMessage$Handshake$Companion$$childSerializers$_anonymous__75pzc2_0)];
  }
}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.internal.transport.RPCProtocolMessage.Handshake', this, 3);
    tmp0_serialDesc.h1b('supportedPlugins', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.m8s_1 = tmp0_serialDesc;
  }
  n8s(encoder, value) {
    var tmp0_desc = this.m8s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().l8s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w8q_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.x8q_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, LongSerializer_getInstance(), value.x8q_1);
    }
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mutableMapOf' call
      var tmp$ret$0 = LinkedHashMap.m7();
      tmp = !equals(value.y8q_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.y8q_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n8s(encoder, value instanceof Handshake ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m8s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_4().l8s_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return Handshake.o8s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.m8s_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_4().l8s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(LongSerializer_getInstance()), tmp0_cached[2].k3()];
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, KrpcProtocolMessage$Failure$Companion$$childSerializers$_anonymous__ryzebz);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p8s_1 = [null, null, tmp_1, lazy_0(tmp_2, KrpcProtocolMessage$Failure$Companion$$childSerializers$_anonymous__ryzebz_0)];
  }
}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.internal.transport.RPCProtocolMessage.Failure', this, 4);
    tmp0_serialDesc.h1b('errorMessage', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('failedMessage', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.q8s_1 = tmp0_serialDesc;
  }
  r8s(encoder, value) {
    var tmp0_desc = this.q8s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_5().p8s_1;
    tmp1_output.e15(tmp0_desc, 0, value.s8s_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.t8s_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, LongSerializer_getInstance(), value.t8s_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.u8s_1 == null)) {
      tmp1_output.i15(tmp0_desc, 2, tmp2_cached[2].k3(), value.u8s_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !equals(value.v8s_1, emptyMap())) {
      tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.v8s_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r8s(encoder, value instanceof Failure_0 ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q8s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_5().p8s_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.d14(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.d14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.d14(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.d14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return Failure_0.w8s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.q8s_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_5().p8s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[2].k3()), tmp0_cached[3].k3()];
  }
}
class KrpcProtocolMessage {}
class Handshake {
  constructor(supportedPlugins, connectionId, pluginParams) {
    Companion_getInstance_4();
    connectionId = connectionId === VOID ? null : connectionId;
    var tmp;
    if (pluginParams === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap.m7();
    } else {
      tmp = pluginParams;
    }
    pluginParams = tmp;
    this.w8q_1 = supportedPlugins;
    this.x8q_1 = connectionId;
    this.y8q_1 = pluginParams;
  }
  c8r() {
    return this.x8q_1;
  }
  i8s() {
    return this.y8q_1;
  }
  toString() {
    return 'Handshake(supportedPlugins=' + toString(this.w8q_1) + ', connectionId=' + toString_0(this.x8q_1) + ', pluginParams=' + toString(this.y8q_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.w8q_1);
    result = imul(result, 31) + (this.x8q_1 == null ? 0 : this.x8q_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.y8q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Handshake))
      return false;
    if (!equals(this.w8q_1, other.w8q_1))
      return false;
    if (!equals(this.x8q_1, other.x8q_1))
      return false;
    if (!equals(this.y8q_1, other.y8q_1))
      return false;
    return true;
  }
  static o8s(seen0, supportedPlugins, connectionId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_4();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_0().m8s_1);
    }
    var $this = createThis(this);
    $this.w8q_1 = supportedPlugins;
    if (0 === (seen0 & 2))
      $this.x8q_1 = null;
    else
      $this.x8q_1 = connectionId;
    if (0 === (seen0 & 4)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp.y8q_1 = LinkedHashMap.m7();
    } else
      $this.y8q_1 = pluginParams;
    return $this;
  }
}
class Failure_0 {
  constructor(errorMessage, connectionId, failedMessage, pluginParams) {
    Companion_getInstance_5();
    connectionId = connectionId === VOID ? null : connectionId;
    failedMessage = failedMessage === VOID ? null : failedMessage;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.s8s_1 = errorMessage;
    this.t8s_1 = connectionId;
    this.u8s_1 = failedMessage;
    this.v8s_1 = pluginParams;
  }
  c8r() {
    return this.t8s_1;
  }
  i8s() {
    return this.v8s_1;
  }
  toString() {
    return 'Failure(errorMessage=' + this.s8s_1 + ', connectionId=' + toString_0(this.t8s_1) + ', failedMessage=' + toString_0(this.u8s_1) + ', pluginParams=' + toString(this.v8s_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s8s_1);
    result = imul(result, 31) + (this.t8s_1 == null ? 0 : this.t8s_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u8s_1 == null ? 0 : hashCode(this.u8s_1)) | 0;
    result = imul(result, 31) + hashCode(this.v8s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Failure_0))
      return false;
    if (!(this.s8s_1 === other.s8s_1))
      return false;
    if (!equals(this.t8s_1, other.t8s_1))
      return false;
    if (!equals(this.u8s_1, other.u8s_1))
      return false;
    if (!equals(this.v8s_1, other.v8s_1))
      return false;
    return true;
  }
  static w8s(seen0, errorMessage, connectionId, failedMessage, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_5();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().q8s_1);
    }
    var $this = createThis(this);
    $this.s8s_1 = errorMessage;
    if (0 === (seen0 & 2))
      $this.t8s_1 = null;
    else
      $this.t8s_1 = connectionId;
    if (0 === (seen0 & 4))
      $this.u8s_1 = null;
    else
      $this.u8s_1 = failedMessage;
    if (0 === (seen0 & 8))
      $this.v8s_1 = emptyMap();
    else
      $this.v8s_1 = pluginParams;
    return $this;
  }
}
class Companion_4 {
  a2g() {
    var tmp = getKClass(KrpcProtocolMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Failure_0), getKClass(Handshake)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_1(), $serializer_getInstance_0()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('org.jetbrains.krpc.internal.transport.RPCProtocolMessage', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_5 {
  a2g() {
    var tmp = getKClass(KrpcMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CallDataBinary), getKClass(CallDataString), getKClass(CallException), getKClass(CallSuccessBinary), getKClass(CallSuccessString), getKClass(StreamCancel), getKClass(StreamFinished), getKClass(StreamMessageBinary), getKClass(StreamMessageString), getKClass(KrpcGenericMessage), getKClass(Failure_0), getKClass(Handshake)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_3(), $serializer_getInstance_2(), $serializer_getInstance_6(), $serializer_getInstance_5(), $serializer_getInstance_4(), $serializer_getInstance_9(), $serializer_getInstance_10(), $serializer_getInstance_8(), $serializer_getInstance_7(), $serializer_getInstance(), $serializer_getInstance_1(), $serializer_getInstance_0()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('org.jetbrains.krpc.internal.transport.RPCMessage', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class BinaryData {}
class StringData {}
class Companion_6 {
  a2g() {
    var tmp = getKClass(CallData);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CallDataBinary), getKClass(CallDataString)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_3(), $serializer_getInstance_2()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('org.jetbrains.krpc.internal.transport.RPCMessage.CallData', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y8s_1 = lazy_0(tmp_0, KrpcCallMessage$CallType$Companion$_anonymous__9xv5fm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, KrpcCallMessage$CallDataString$Companion$$childSerializers$_anonymous__qxf5qc);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z8s_1 = [null, null, null, tmp_1, null, null, null, lazy_0(tmp_2, KrpcCallMessage$CallDataString$Companion$$childSerializers$_anonymous__qxf5qc_0)];
  }
}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.RPCMessage.CallData', this, 8);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('method', false);
    tmp0_serialDesc.h1b('callType', false);
    tmp0_serialDesc.h1b('data', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.a8t_1 = tmp0_serialDesc;
  }
  b8t(encoder, value) {
    var tmp0_desc = this.a8t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().z8s_1;
    tmp1_output.e15(tmp0_desc, 0, value.c8t_1);
    tmp1_output.e15(tmp0_desc, 1, value.d8t_1);
    tmp1_output.e15(tmp0_desc, 2, value.e8t_1);
    tmp1_output.i15(tmp0_desc, 3, tmp2_cached[3].k3(), value.f8t_1);
    tmp1_output.e15(tmp0_desc, 4, value.g8t_1);
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.h8t_1 == null)) {
      tmp1_output.i15(tmp0_desc, 5, LongSerializer_getInstance(), value.h8t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !(value.i8t_1 == null)) {
      tmp1_output.i15(tmp0_desc, 6, LongSerializer_getInstance(), value.i8t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 7) ? true : !equals(value.j8t_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 7, tmp2_cached[7].k3(), value.j8t_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b8t(encoder, value instanceof CallDataString ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a8t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.p13(tmp0_desc);
    var tmp13_cached = Companion_getInstance_10().z8s_1;
    if (tmp12_input.e14()) {
      tmp4_local0 = tmp12_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.d14(tmp0_desc, 3, tmp13_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.z13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.d14(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.d14(tmp0_desc, 7, tmp13_cached[7].k3(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.d14(tmp0_desc, 3, tmp13_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.z13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.d14(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.d14(tmp0_desc, 7, tmp13_cached[7].k3(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp12_input.q13(tmp0_desc);
    return CallDataString.k8t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  dz() {
    return this.a8t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_10().z8s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[3].k3()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[7].k3())];
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, KrpcCallMessage$CallDataBinary$Companion$$childSerializers$_anonymous__f2hayc);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l8t_1 = [null, null, null, tmp_1, null, null, null, lazy_0(tmp_2, KrpcCallMessage$CallDataBinary$Companion$$childSerializers$_anonymous__f2hayc_0)];
  }
}
class $serializer_3 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.internal.transport.RPCMessage.CallDataBinary', this, 8);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('method', false);
    tmp0_serialDesc.h1b('callType', false);
    tmp0_serialDesc.h1b('data', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.m8t_1 = tmp0_serialDesc;
  }
  n8t(encoder, value) {
    var tmp0_desc = this.m8t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().l8t_1;
    tmp1_output.e15(tmp0_desc, 0, value.o8t_1);
    tmp1_output.e15(tmp0_desc, 1, value.p8t_1);
    tmp1_output.e15(tmp0_desc, 2, value.q8t_1);
    tmp1_output.i15(tmp0_desc, 3, tmp2_cached[3].k3(), value.r8t_1);
    tmp1_output.g15(tmp0_desc, 4, ByteArraySerializer_getInstance(), value.s8t_1);
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.t8t_1 == null)) {
      tmp1_output.i15(tmp0_desc, 5, LongSerializer_getInstance(), value.t8t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !(value.u8t_1 == null)) {
      tmp1_output.i15(tmp0_desc, 6, LongSerializer_getInstance(), value.u8t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 7) ? true : !equals(value.v8t_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 7, tmp2_cached[7].k3(), value.v8t_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n8t(encoder, value instanceof CallDataBinary ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m8t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.p13(tmp0_desc);
    var tmp13_cached = Companion_getInstance_11().l8t_1;
    if (tmp12_input.e14()) {
      tmp4_local0 = tmp12_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.d14(tmp0_desc, 3, tmp13_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.b14(tmp0_desc, 4, ByteArraySerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.d14(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.d14(tmp0_desc, 7, tmp13_cached[7].k3(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.d14(tmp0_desc, 3, tmp13_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.b14(tmp0_desc, 4, ByteArraySerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.d14(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.d14(tmp0_desc, 7, tmp13_cached[7].k3(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp12_input.q13(tmp0_desc);
    return CallDataBinary.w8t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  dz() {
    return this.m8t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_11().l8t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[3].k3()), ByteArraySerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[7].k3())];
  }
}
class Companion_10 {
  a2g() {
    var tmp = getKClass(CallSuccess);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CallSuccessBinary), getKClass(CallSuccessString)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_5(), $serializer_getInstance_4()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('org.jetbrains.krpc.internal.transport.RPCMessage.CallSuccess', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x8t_1 = [null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$CallSuccessString$Companion$$childSerializers$_anonymous__vs64gn)];
  }
}
class $serializer_4 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.RPCMessage.CallSuccess', this, 6);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('data', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.y8t_1 = tmp0_serialDesc;
  }
  z8t(encoder, value) {
    var tmp0_desc = this.y8t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().x8t_1;
    tmp1_output.e15(tmp0_desc, 0, value.a8u_1);
    tmp1_output.e15(tmp0_desc, 1, value.b8u_1);
    tmp1_output.e15(tmp0_desc, 2, value.c8u_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.d8u_1 == null)) {
      tmp1_output.i15(tmp0_desc, 3, LongSerializer_getInstance(), value.d8u_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.e8u_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.e8u_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !equals(value.f8u_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 5, tmp2_cached[5].k3(), value.f8u_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z8t(encoder, value instanceof CallSuccessString ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y8t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.p13(tmp0_desc);
    var tmp11_cached = Companion_getInstance_13().x8t_1;
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return CallSuccessString.g8u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.y8t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_13().x8t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[5].k3())];
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h8u_1 = [null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$CallSuccessBinary$Companion$$childSerializers$_anonymous__jx89on)];
  }
}
class $serializer_5 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.internal.transport.RPCMessage.CallSuccessBinary', this, 6);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('data', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.i8u_1 = tmp0_serialDesc;
  }
  j8u(encoder, value) {
    var tmp0_desc = this.i8u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().h8u_1;
    tmp1_output.e15(tmp0_desc, 0, value.k8u_1);
    tmp1_output.e15(tmp0_desc, 1, value.l8u_1);
    tmp1_output.g15(tmp0_desc, 2, ByteArraySerializer_getInstance(), value.m8u_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.n8u_1 == null)) {
      tmp1_output.i15(tmp0_desc, 3, LongSerializer_getInstance(), value.n8u_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.o8u_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.o8u_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !equals(value.p8u_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 5, tmp2_cached[5].k3(), value.p8u_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j8u(encoder, value instanceof CallSuccessBinary ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i8u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.p13(tmp0_desc);
    var tmp11_cached = Companion_getInstance_14().h8u_1;
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, ByteArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, ByteArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return CallSuccessBinary.q8u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.i8u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_14().h8u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), ByteArraySerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[5].k3())];
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r8u_1 = [null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$CallException$Companion$$childSerializers$_anonymous__kkmq6m)];
  }
}
class $serializer_6 {
  constructor() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.RPCMessage.CallException', this, 6);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('cause', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.s8u_1 = tmp0_serialDesc;
  }
  t8u(encoder, value) {
    var tmp0_desc = this.s8u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().r8u_1;
    tmp1_output.e15(tmp0_desc, 0, value.u8u_1);
    tmp1_output.e15(tmp0_desc, 1, value.v8u_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_11(), value.w8u_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.x8u_1 == null)) {
      tmp1_output.i15(tmp0_desc, 3, LongSerializer_getInstance(), value.x8u_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.y8u_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.y8u_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !equals(value.z8u_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 5, tmp2_cached[5].k3(), value.z8u_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t8u(encoder, value instanceof CallException ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s8u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.p13(tmp0_desc);
    var tmp11_cached = Companion_getInstance_15().r8u_1;
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return CallException.a8v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.s8u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_15().r8u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_11(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[5].k3())];
  }
}
class Companion_14 {
  a2g() {
    var tmp = getKClass(StreamMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(StreamMessageBinary), getKClass(StreamMessageString)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_8(), $serializer_getInstance_7()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('org.jetbrains.krpc.internal.transport.RPCMessage.StreamMessage', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b8v_1 = [null, null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$StreamMessageString$Companion$$childSerializers$_anonymous__ceqgsn)];
  }
}
class $serializer_7 {
  constructor() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.RPCMessage.StreamMessage', this, 7);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('flowId', false);
    tmp0_serialDesc.h1b('data', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.c8v_1 = tmp0_serialDesc;
  }
  d8v(encoder, value) {
    var tmp0_desc = this.c8v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_17().b8v_1;
    tmp1_output.e15(tmp0_desc, 0, value.e8v_1);
    tmp1_output.e15(tmp0_desc, 1, value.f8v_1);
    tmp1_output.e15(tmp0_desc, 2, value.g8v_1);
    tmp1_output.e15(tmp0_desc, 3, value.h8v_1);
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.i8v_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.i8v_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.j8v_1 == null)) {
      tmp1_output.i15(tmp0_desc, 5, LongSerializer_getInstance(), value.j8v_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !equals(value.k8v_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 6, tmp2_cached[6].k3(), value.k8v_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d8v(encoder, value instanceof StreamMessageString ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c8v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_17().b8v_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.z13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.z13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return StreamMessageString.l8v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.c8v_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_17().b8v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[6].k3())];
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m8v_1 = [null, null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$StreamMessageBinary$Companion$$childSerializers$_anonymous__o9obkn)];
  }
}
class $serializer_8 {
  constructor() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.internal.transport.RPCMessage.StreamMessageBinary', this, 7);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('flowId', false);
    tmp0_serialDesc.h1b('data', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.n8v_1 = tmp0_serialDesc;
  }
  o8v(encoder, value) {
    var tmp0_desc = this.n8v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().m8v_1;
    tmp1_output.e15(tmp0_desc, 0, value.p8v_1);
    tmp1_output.e15(tmp0_desc, 1, value.q8v_1);
    tmp1_output.e15(tmp0_desc, 2, value.r8v_1);
    tmp1_output.g15(tmp0_desc, 3, ByteArraySerializer_getInstance(), value.s8v_1);
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.t8v_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.t8v_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.u8v_1 == null)) {
      tmp1_output.i15(tmp0_desc, 5, LongSerializer_getInstance(), value.u8v_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !equals(value.v8v_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 6, tmp2_cached[6].k3(), value.v8v_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o8v(encoder, value instanceof StreamMessageBinary ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n8v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_18().m8v_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, ByteArraySerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, ByteArraySerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return StreamMessageBinary.w8v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.n8v_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_18().m8v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), ByteArraySerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[6].k3())];
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x8v_1 = [null, null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$StreamCancel$Companion$$childSerializers$_anonymous__8dkz0b)];
  }
}
class $serializer_9 {
  constructor() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.RPCMessage.StreamCancel', this, 7);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('flowId', false);
    tmp0_serialDesc.h1b('cause', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.y8v_1 = tmp0_serialDesc;
  }
  z8v(encoder, value) {
    var tmp0_desc = this.y8v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_19().x8v_1;
    tmp1_output.e15(tmp0_desc, 0, value.a8w_1);
    tmp1_output.e15(tmp0_desc, 1, value.b8w_1);
    tmp1_output.e15(tmp0_desc, 2, value.c8w_1);
    tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_11(), value.d8w_1);
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.e8w_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.e8w_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.f8w_1 == null)) {
      tmp1_output.i15(tmp0_desc, 5, LongSerializer_getInstance(), value.f8w_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !equals(value.g8w_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 6, tmp2_cached[6].k3(), value.g8w_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z8v(encoder, value instanceof StreamCancel ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y8v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_19().x8v_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, $serializer_getInstance_11(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, $serializer_getInstance_11(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return StreamCancel.h8w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.y8v_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_19().x8v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_11(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[6].k3())];
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i8w_1 = [null, null, null, null, null, lazy_0(tmp_0, KrpcCallMessage$StreamFinished$Companion$$childSerializers$_anonymous__grebnh)];
  }
}
class $serializer_10 {
  constructor() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.RPCMessage.StreamFinished', this, 6);
    tmp0_serialDesc.h1b('callId', false);
    tmp0_serialDesc.h1b('serviceType', false);
    tmp0_serialDesc.h1b('flowId', false);
    tmp0_serialDesc.h1b('connectionId', true);
    tmp0_serialDesc.h1b('serviceId', true);
    tmp0_serialDesc.h1b('pluginParams', true);
    this.j8w_1 = tmp0_serialDesc;
  }
  k8w(encoder, value) {
    var tmp0_desc = this.j8w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_20().i8w_1;
    tmp1_output.e15(tmp0_desc, 0, value.l8w_1);
    tmp1_output.e15(tmp0_desc, 1, value.m8w_1);
    tmp1_output.e15(tmp0_desc, 2, value.n8w_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.o8w_1 == null)) {
      tmp1_output.i15(tmp0_desc, 3, LongSerializer_getInstance(), value.o8w_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.p8w_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, LongSerializer_getInstance(), value.p8w_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !equals(value.q8w_1, emptyMap())) {
      tmp1_output.i15(tmp0_desc, 5, tmp2_cached[5].k3(), value.q8w_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k8w(encoder, value instanceof StreamFinished ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j8w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.p13(tmp0_desc);
    var tmp11_cached = Companion_getInstance_20().i8w_1;
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.z13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.z13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.d14(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, tmp11_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return StreamFinished.r8w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.j8w_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_20().i8w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[5].k3())];
  }
}
class KrpcCallMessage {}
class CallData {}
class CallType extends Enum {}
class CallDataString {
  constructor(callId, serviceType, callableName, callType, data, connectionId, serviceId, pluginParams) {
    Companion_getInstance_10();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.c8t_1 = callId;
    this.d8t_1 = serviceType;
    this.e8t_1 = callableName;
    this.f8t_1 = callType;
    this.g8t_1 = data;
    this.h8t_1 = connectionId;
    this.i8t_1 = serviceId;
    this.j8t_1 = pluginParams;
  }
  e8r() {
    return this.c8t_1;
  }
  d8r() {
    return this.d8t_1;
  }
  x8s() {
    return this.g8t_1;
  }
  c8r() {
    return this.h8t_1;
  }
  f8r() {
    return this.i8t_1;
  }
  i8s() {
    return this.j8t_1;
  }
  toString() {
    return 'CallDataString(callId=' + this.c8t_1 + ', serviceType=' + this.d8t_1 + ', callableName=' + this.e8t_1 + ', callType=' + toString_0(this.f8t_1) + ', data=' + this.g8t_1 + ', connectionId=' + toString_0(this.h8t_1) + ', serviceId=' + toString_0(this.i8t_1) + ', pluginParams=' + toString_0(this.j8t_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.c8t_1);
    result = imul(result, 31) + getStringHashCode(this.d8t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e8t_1) | 0;
    result = imul(result, 31) + (this.f8t_1 == null ? 0 : this.f8t_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.g8t_1) | 0;
    result = imul(result, 31) + (this.h8t_1 == null ? 0 : this.h8t_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i8t_1 == null ? 0 : this.i8t_1.hashCode()) | 0;
    result = imul(result, 31) + (this.j8t_1 == null ? 0 : hashCode(this.j8t_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CallDataString))
      return false;
    if (!(this.c8t_1 === other.c8t_1))
      return false;
    if (!(this.d8t_1 === other.d8t_1))
      return false;
    if (!(this.e8t_1 === other.e8t_1))
      return false;
    if (!equals(this.f8t_1, other.f8t_1))
      return false;
    if (!(this.g8t_1 === other.g8t_1))
      return false;
    if (!equals(this.h8t_1, other.h8t_1))
      return false;
    if (!equals(this.i8t_1, other.i8t_1))
      return false;
    if (!equals(this.j8t_1, other.j8t_1))
      return false;
    return true;
  }
  static k8t(seen0, callId, serviceType, callableName, callType, data, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_10();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_2().a8t_1);
    }
    var $this = createThis(this);
    $this.c8t_1 = callId;
    $this.d8t_1 = serviceType;
    $this.e8t_1 = callableName;
    $this.f8t_1 = callType;
    $this.g8t_1 = data;
    if (0 === (seen0 & 32))
      $this.h8t_1 = null;
    else
      $this.h8t_1 = connectionId;
    if (0 === (seen0 & 64))
      $this.i8t_1 = null;
    else
      $this.i8t_1 = serviceId;
    if (0 === (seen0 & 128))
      $this.j8t_1 = emptyMap();
    else
      $this.j8t_1 = pluginParams;
    return $this;
  }
}
class CallDataBinary {
  constructor(callId, serviceType, callableName, callType, data, connectionId, serviceId, pluginParams) {
    Companion_getInstance_11();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.o8t_1 = callId;
    this.p8t_1 = serviceType;
    this.q8t_1 = callableName;
    this.r8t_1 = callType;
    this.s8t_1 = data;
    this.t8t_1 = connectionId;
    this.u8t_1 = serviceId;
    this.v8t_1 = pluginParams;
  }
  e8r() {
    return this.o8t_1;
  }
  d8r() {
    return this.p8t_1;
  }
  x8s() {
    return this.s8t_1;
  }
  c8r() {
    return this.t8t_1;
  }
  f8r() {
    return this.u8t_1;
  }
  i8s() {
    return this.v8t_1;
  }
  toString() {
    return 'CallDataBinary(callId=' + this.o8t_1 + ', serviceType=' + this.p8t_1 + ', callableName=' + this.q8t_1 + ', callType=' + toString_0(this.r8t_1) + ', data=' + toString(this.s8t_1) + ', connectionId=' + toString_0(this.t8t_1) + ', serviceId=' + toString_0(this.u8t_1) + ', pluginParams=' + toString_0(this.v8t_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.o8t_1);
    result = imul(result, 31) + getStringHashCode(this.p8t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q8t_1) | 0;
    result = imul(result, 31) + (this.r8t_1 == null ? 0 : this.r8t_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.s8t_1) | 0;
    result = imul(result, 31) + (this.t8t_1 == null ? 0 : this.t8t_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u8t_1 == null ? 0 : this.u8t_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v8t_1 == null ? 0 : hashCode(this.v8t_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CallDataBinary))
      return false;
    if (!(this.o8t_1 === other.o8t_1))
      return false;
    if (!(this.p8t_1 === other.p8t_1))
      return false;
    if (!(this.q8t_1 === other.q8t_1))
      return false;
    if (!equals(this.r8t_1, other.r8t_1))
      return false;
    if (!equals(this.s8t_1, other.s8t_1))
      return false;
    if (!equals(this.t8t_1, other.t8t_1))
      return false;
    if (!equals(this.u8t_1, other.u8t_1))
      return false;
    if (!equals(this.v8t_1, other.v8t_1))
      return false;
    return true;
  }
  static w8t(seen0, callId, serviceType, callableName, callType, data, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_11();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_3().m8t_1);
    }
    var $this = createThis(this);
    $this.o8t_1 = callId;
    $this.p8t_1 = serviceType;
    $this.q8t_1 = callableName;
    $this.r8t_1 = callType;
    $this.s8t_1 = data;
    if (0 === (seen0 & 32))
      $this.t8t_1 = null;
    else
      $this.t8t_1 = connectionId;
    if (0 === (seen0 & 64))
      $this.u8t_1 = null;
    else
      $this.u8t_1 = serviceId;
    if (0 === (seen0 & 128))
      $this.v8t_1 = emptyMap();
    else
      $this.v8t_1 = pluginParams;
    return $this;
  }
}
class CallSuccess {}
class CallSuccessString {
  constructor(callId, serviceType, data, connectionId, serviceId, pluginParams) {
    Companion_getInstance_13();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.a8u_1 = callId;
    this.b8u_1 = serviceType;
    this.c8u_1 = data;
    this.d8u_1 = connectionId;
    this.e8u_1 = serviceId;
    this.f8u_1 = pluginParams;
  }
  e8r() {
    return this.a8u_1;
  }
  d8r() {
    return this.b8u_1;
  }
  x8s() {
    return this.c8u_1;
  }
  c8r() {
    return this.d8u_1;
  }
  f8r() {
    return this.e8u_1;
  }
  i8s() {
    return this.f8u_1;
  }
  toString() {
    return 'CallSuccessString(callId=' + this.a8u_1 + ', serviceType=' + this.b8u_1 + ', data=' + this.c8u_1 + ', connectionId=' + toString_0(this.d8u_1) + ', serviceId=' + toString_0(this.e8u_1) + ', pluginParams=' + toString_0(this.f8u_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a8u_1);
    result = imul(result, 31) + getStringHashCode(this.b8u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c8u_1) | 0;
    result = imul(result, 31) + (this.d8u_1 == null ? 0 : this.d8u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.e8u_1 == null ? 0 : this.e8u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f8u_1 == null ? 0 : hashCode(this.f8u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CallSuccessString))
      return false;
    if (!(this.a8u_1 === other.a8u_1))
      return false;
    if (!(this.b8u_1 === other.b8u_1))
      return false;
    if (!(this.c8u_1 === other.c8u_1))
      return false;
    if (!equals(this.d8u_1, other.d8u_1))
      return false;
    if (!equals(this.e8u_1, other.e8u_1))
      return false;
    if (!equals(this.f8u_1, other.f8u_1))
      return false;
    return true;
  }
  static g8u(seen0, callId, serviceType, data, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_13();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_4().y8t_1);
    }
    var $this = createThis(this);
    $this.a8u_1 = callId;
    $this.b8u_1 = serviceType;
    $this.c8u_1 = data;
    if (0 === (seen0 & 8))
      $this.d8u_1 = null;
    else
      $this.d8u_1 = connectionId;
    if (0 === (seen0 & 16))
      $this.e8u_1 = null;
    else
      $this.e8u_1 = serviceId;
    if (0 === (seen0 & 32))
      $this.f8u_1 = emptyMap();
    else
      $this.f8u_1 = pluginParams;
    return $this;
  }
}
class CallSuccessBinary {
  constructor(callId, serviceType, data, connectionId, serviceId, pluginParams) {
    Companion_getInstance_14();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.k8u_1 = callId;
    this.l8u_1 = serviceType;
    this.m8u_1 = data;
    this.n8u_1 = connectionId;
    this.o8u_1 = serviceId;
    this.p8u_1 = pluginParams;
  }
  e8r() {
    return this.k8u_1;
  }
  d8r() {
    return this.l8u_1;
  }
  x8s() {
    return this.m8u_1;
  }
  c8r() {
    return this.n8u_1;
  }
  f8r() {
    return this.o8u_1;
  }
  i8s() {
    return this.p8u_1;
  }
  toString() {
    return 'CallSuccessBinary(callId=' + this.k8u_1 + ', serviceType=' + this.l8u_1 + ', data=' + toString(this.m8u_1) + ', connectionId=' + toString_0(this.n8u_1) + ', serviceId=' + toString_0(this.o8u_1) + ', pluginParams=' + toString_0(this.p8u_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.k8u_1);
    result = imul(result, 31) + getStringHashCode(this.l8u_1) | 0;
    result = imul(result, 31) + hashCode(this.m8u_1) | 0;
    result = imul(result, 31) + (this.n8u_1 == null ? 0 : this.n8u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.o8u_1 == null ? 0 : this.o8u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p8u_1 == null ? 0 : hashCode(this.p8u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CallSuccessBinary))
      return false;
    if (!(this.k8u_1 === other.k8u_1))
      return false;
    if (!(this.l8u_1 === other.l8u_1))
      return false;
    if (!equals(this.m8u_1, other.m8u_1))
      return false;
    if (!equals(this.n8u_1, other.n8u_1))
      return false;
    if (!equals(this.o8u_1, other.o8u_1))
      return false;
    if (!equals(this.p8u_1, other.p8u_1))
      return false;
    return true;
  }
  static q8u(seen0, callId, serviceType, data, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_14();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_5().i8u_1);
    }
    var $this = createThis(this);
    $this.k8u_1 = callId;
    $this.l8u_1 = serviceType;
    $this.m8u_1 = data;
    if (0 === (seen0 & 8))
      $this.n8u_1 = null;
    else
      $this.n8u_1 = connectionId;
    if (0 === (seen0 & 16))
      $this.o8u_1 = null;
    else
      $this.o8u_1 = serviceId;
    if (0 === (seen0 & 32))
      $this.p8u_1 = emptyMap();
    else
      $this.p8u_1 = pluginParams;
    return $this;
  }
}
class CallException {
  constructor(callId, serviceType, cause, connectionId, serviceId, pluginParams) {
    Companion_getInstance_15();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.u8u_1 = callId;
    this.v8u_1 = serviceType;
    this.w8u_1 = cause;
    this.x8u_1 = connectionId;
    this.y8u_1 = serviceId;
    this.z8u_1 = pluginParams;
  }
  e8r() {
    return this.u8u_1;
  }
  d8r() {
    return this.v8u_1;
  }
  c8r() {
    return this.x8u_1;
  }
  f8r() {
    return this.y8u_1;
  }
  i8s() {
    return this.z8u_1;
  }
  toString() {
    return 'CallException(callId=' + this.u8u_1 + ', serviceType=' + this.v8u_1 + ', cause=' + this.w8u_1.toString() + ', connectionId=' + toString_0(this.x8u_1) + ', serviceId=' + toString_0(this.y8u_1) + ', pluginParams=' + toString_0(this.z8u_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.u8u_1);
    result = imul(result, 31) + getStringHashCode(this.v8u_1) | 0;
    result = imul(result, 31) + this.w8u_1.hashCode() | 0;
    result = imul(result, 31) + (this.x8u_1 == null ? 0 : this.x8u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y8u_1 == null ? 0 : this.y8u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z8u_1 == null ? 0 : hashCode(this.z8u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CallException))
      return false;
    if (!(this.u8u_1 === other.u8u_1))
      return false;
    if (!(this.v8u_1 === other.v8u_1))
      return false;
    if (!this.w8u_1.equals(other.w8u_1))
      return false;
    if (!equals(this.x8u_1, other.x8u_1))
      return false;
    if (!equals(this.y8u_1, other.y8u_1))
      return false;
    if (!equals(this.z8u_1, other.z8u_1))
      return false;
    return true;
  }
  static a8v(seen0, callId, serviceType, cause, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_15();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_6().s8u_1);
    }
    var $this = createThis(this);
    $this.u8u_1 = callId;
    $this.v8u_1 = serviceType;
    $this.w8u_1 = cause;
    if (0 === (seen0 & 8))
      $this.x8u_1 = null;
    else
      $this.x8u_1 = connectionId;
    if (0 === (seen0 & 16))
      $this.y8u_1 = null;
    else
      $this.y8u_1 = serviceId;
    if (0 === (seen0 & 32))
      $this.z8u_1 = emptyMap();
    else
      $this.z8u_1 = pluginParams;
    return $this;
  }
}
class StreamMessage {}
class StreamMessageString {
  constructor(callId, serviceType, streamId, data, connectionId, serviceId, pluginParams) {
    Companion_getInstance_17();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.e8v_1 = callId;
    this.f8v_1 = serviceType;
    this.g8v_1 = streamId;
    this.h8v_1 = data;
    this.i8v_1 = connectionId;
    this.j8v_1 = serviceId;
    this.k8v_1 = pluginParams;
  }
  e8r() {
    return this.e8v_1;
  }
  d8r() {
    return this.f8v_1;
  }
  x8s() {
    return this.h8v_1;
  }
  c8r() {
    return this.i8v_1;
  }
  f8r() {
    return this.j8v_1;
  }
  i8s() {
    return this.k8v_1;
  }
  toString() {
    return 'StreamMessageString(callId=' + this.e8v_1 + ', serviceType=' + this.f8v_1 + ', streamId=' + this.g8v_1 + ', data=' + this.h8v_1 + ', connectionId=' + toString_0(this.i8v_1) + ', serviceId=' + toString_0(this.j8v_1) + ', pluginParams=' + toString_0(this.k8v_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.e8v_1);
    result = imul(result, 31) + getStringHashCode(this.f8v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g8v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h8v_1) | 0;
    result = imul(result, 31) + (this.i8v_1 == null ? 0 : this.i8v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.j8v_1 == null ? 0 : this.j8v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.k8v_1 == null ? 0 : hashCode(this.k8v_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StreamMessageString))
      return false;
    if (!(this.e8v_1 === other.e8v_1))
      return false;
    if (!(this.f8v_1 === other.f8v_1))
      return false;
    if (!(this.g8v_1 === other.g8v_1))
      return false;
    if (!(this.h8v_1 === other.h8v_1))
      return false;
    if (!equals(this.i8v_1, other.i8v_1))
      return false;
    if (!equals(this.j8v_1, other.j8v_1))
      return false;
    if (!equals(this.k8v_1, other.k8v_1))
      return false;
    return true;
  }
  static l8v(seen0, callId, serviceType, streamId, data, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_17();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_7().c8v_1);
    }
    var $this = createThis(this);
    $this.e8v_1 = callId;
    $this.f8v_1 = serviceType;
    $this.g8v_1 = streamId;
    $this.h8v_1 = data;
    if (0 === (seen0 & 16))
      $this.i8v_1 = null;
    else
      $this.i8v_1 = connectionId;
    if (0 === (seen0 & 32))
      $this.j8v_1 = null;
    else
      $this.j8v_1 = serviceId;
    if (0 === (seen0 & 64))
      $this.k8v_1 = emptyMap();
    else
      $this.k8v_1 = pluginParams;
    return $this;
  }
}
class StreamMessageBinary {
  constructor(callId, serviceType, streamId, data, connectionId, serviceId, pluginParams) {
    Companion_getInstance_18();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.p8v_1 = callId;
    this.q8v_1 = serviceType;
    this.r8v_1 = streamId;
    this.s8v_1 = data;
    this.t8v_1 = connectionId;
    this.u8v_1 = serviceId;
    this.v8v_1 = pluginParams;
  }
  e8r() {
    return this.p8v_1;
  }
  d8r() {
    return this.q8v_1;
  }
  x8s() {
    return this.s8v_1;
  }
  c8r() {
    return this.t8v_1;
  }
  f8r() {
    return this.u8v_1;
  }
  i8s() {
    return this.v8v_1;
  }
  toString() {
    return 'StreamMessageBinary(callId=' + this.p8v_1 + ', serviceType=' + this.q8v_1 + ', streamId=' + this.r8v_1 + ', data=' + toString(this.s8v_1) + ', connectionId=' + toString_0(this.t8v_1) + ', serviceId=' + toString_0(this.u8v_1) + ', pluginParams=' + toString_0(this.v8v_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.p8v_1);
    result = imul(result, 31) + getStringHashCode(this.q8v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r8v_1) | 0;
    result = imul(result, 31) + hashCode(this.s8v_1) | 0;
    result = imul(result, 31) + (this.t8v_1 == null ? 0 : this.t8v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u8v_1 == null ? 0 : this.u8v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v8v_1 == null ? 0 : hashCode(this.v8v_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StreamMessageBinary))
      return false;
    if (!(this.p8v_1 === other.p8v_1))
      return false;
    if (!(this.q8v_1 === other.q8v_1))
      return false;
    if (!(this.r8v_1 === other.r8v_1))
      return false;
    if (!equals(this.s8v_1, other.s8v_1))
      return false;
    if (!equals(this.t8v_1, other.t8v_1))
      return false;
    if (!equals(this.u8v_1, other.u8v_1))
      return false;
    if (!equals(this.v8v_1, other.v8v_1))
      return false;
    return true;
  }
  static w8v(seen0, callId, serviceType, streamId, data, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_18();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_8().n8v_1);
    }
    var $this = createThis(this);
    $this.p8v_1 = callId;
    $this.q8v_1 = serviceType;
    $this.r8v_1 = streamId;
    $this.s8v_1 = data;
    if (0 === (seen0 & 16))
      $this.t8v_1 = null;
    else
      $this.t8v_1 = connectionId;
    if (0 === (seen0 & 32))
      $this.u8v_1 = null;
    else
      $this.u8v_1 = serviceId;
    if (0 === (seen0 & 64))
      $this.v8v_1 = emptyMap();
    else
      $this.v8v_1 = pluginParams;
    return $this;
  }
}
class StreamCancel {
  constructor(callId, serviceType, streamId, cause, connectionId, serviceId, pluginParams) {
    Companion_getInstance_19();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.a8w_1 = callId;
    this.b8w_1 = serviceType;
    this.c8w_1 = streamId;
    this.d8w_1 = cause;
    this.e8w_1 = connectionId;
    this.f8w_1 = serviceId;
    this.g8w_1 = pluginParams;
  }
  e8r() {
    return this.a8w_1;
  }
  d8r() {
    return this.b8w_1;
  }
  c8r() {
    return this.e8w_1;
  }
  f8r() {
    return this.f8w_1;
  }
  i8s() {
    return this.g8w_1;
  }
  toString() {
    return 'StreamCancel(callId=' + this.a8w_1 + ', serviceType=' + this.b8w_1 + ', streamId=' + this.c8w_1 + ', cause=' + this.d8w_1.toString() + ', connectionId=' + toString_0(this.e8w_1) + ', serviceId=' + toString_0(this.f8w_1) + ', pluginParams=' + toString_0(this.g8w_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a8w_1);
    result = imul(result, 31) + getStringHashCode(this.b8w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c8w_1) | 0;
    result = imul(result, 31) + this.d8w_1.hashCode() | 0;
    result = imul(result, 31) + (this.e8w_1 == null ? 0 : this.e8w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f8w_1 == null ? 0 : this.f8w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g8w_1 == null ? 0 : hashCode(this.g8w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StreamCancel))
      return false;
    if (!(this.a8w_1 === other.a8w_1))
      return false;
    if (!(this.b8w_1 === other.b8w_1))
      return false;
    if (!(this.c8w_1 === other.c8w_1))
      return false;
    if (!this.d8w_1.equals(other.d8w_1))
      return false;
    if (!equals(this.e8w_1, other.e8w_1))
      return false;
    if (!equals(this.f8w_1, other.f8w_1))
      return false;
    if (!equals(this.g8w_1, other.g8w_1))
      return false;
    return true;
  }
  static h8w(seen0, callId, serviceType, streamId, cause, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_19();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_9().y8v_1);
    }
    var $this = createThis(this);
    $this.a8w_1 = callId;
    $this.b8w_1 = serviceType;
    $this.c8w_1 = streamId;
    $this.d8w_1 = cause;
    if (0 === (seen0 & 16))
      $this.e8w_1 = null;
    else
      $this.e8w_1 = connectionId;
    if (0 === (seen0 & 32))
      $this.f8w_1 = null;
    else
      $this.f8w_1 = serviceId;
    if (0 === (seen0 & 64))
      $this.g8w_1 = emptyMap();
    else
      $this.g8w_1 = pluginParams;
    return $this;
  }
}
class StreamFinished {
  constructor(callId, serviceType, streamId, connectionId, serviceId, pluginParams) {
    Companion_getInstance_20();
    connectionId = connectionId === VOID ? null : connectionId;
    serviceId = serviceId === VOID ? null : serviceId;
    pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
    this.l8w_1 = callId;
    this.m8w_1 = serviceType;
    this.n8w_1 = streamId;
    this.o8w_1 = connectionId;
    this.p8w_1 = serviceId;
    this.q8w_1 = pluginParams;
  }
  e8r() {
    return this.l8w_1;
  }
  d8r() {
    return this.m8w_1;
  }
  c8r() {
    return this.o8w_1;
  }
  f8r() {
    return this.p8w_1;
  }
  i8s() {
    return this.q8w_1;
  }
  toString() {
    return 'StreamFinished(callId=' + this.l8w_1 + ', serviceType=' + this.m8w_1 + ', streamId=' + this.n8w_1 + ', connectionId=' + toString_0(this.o8w_1) + ', serviceId=' + toString_0(this.p8w_1) + ', pluginParams=' + toString_0(this.q8w_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l8w_1);
    result = imul(result, 31) + getStringHashCode(this.m8w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n8w_1) | 0;
    result = imul(result, 31) + (this.o8w_1 == null ? 0 : this.o8w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p8w_1 == null ? 0 : this.p8w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.q8w_1 == null ? 0 : hashCode(this.q8w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StreamFinished))
      return false;
    if (!(this.l8w_1 === other.l8w_1))
      return false;
    if (!(this.m8w_1 === other.m8w_1))
      return false;
    if (!(this.n8w_1 === other.n8w_1))
      return false;
    if (!equals(this.o8w_1, other.o8w_1))
      return false;
    if (!equals(this.p8w_1, other.p8w_1))
      return false;
    if (!equals(this.q8w_1, other.q8w_1))
      return false;
    return true;
  }
  static r8w(seen0, callId, serviceType, streamId, connectionId, serviceId, pluginParams, serializationConstructorMarker) {
    Companion_getInstance_20();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_10().j8w_1);
    }
    var $this = createThis(this);
    $this.l8w_1 = callId;
    $this.m8w_1 = serviceType;
    $this.n8w_1 = streamId;
    if (0 === (seen0 & 8))
      $this.o8w_1 = null;
    else
      $this.o8w_1 = connectionId;
    if (0 === (seen0 & 16))
      $this.p8w_1 = null;
    else
      $this.p8w_1 = serviceId;
    if (0 === (seen0 & 32))
      $this.q8w_1 = emptyMap();
    else
      $this.q8w_1 = pluginParams;
    return $this;
  }
}
class Companion_19 {
  a2g() {
    var tmp = getKClass(KrpcCallMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CallDataBinary), getKClass(CallDataString), getKClass(CallException), getKClass(CallSuccessBinary), getKClass(CallSuccessString), getKClass(StreamCancel), getKClass(StreamFinished), getKClass(StreamMessageBinary), getKClass(StreamMessageString)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_3(), $serializer_getInstance_2(), $serializer_getInstance_6(), $serializer_getInstance_5(), $serializer_getInstance_4(), $serializer_getInstance_9(), $serializer_getInstance_10(), $serializer_getInstance_8(), $serializer_getInstance_7()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('org.jetbrains.krpc.RPCMessage', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_21 = this;
    this.j8s_1 = minus(toSet(get_entries_0()), KrpcPlugin_UNKNOWN_getInstance());
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k8s_1 = lazy_0(tmp_0, KrpcPlugin$Companion$_anonymous__1hzj8e);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class KrpcPlugin extends Enum {
  constructor(name, ordinal, uniqueIndex, since) {
    super(name, ordinal);
    this.u8w_1 = uniqueIndex;
    this.v8w_1 = since;
  }
  k8p() {
    return this.u8w_1;
  }
}
class RpcInternalShortEnumKSerializer {
  constructor(kClass, unknownValue, allValues) {
    this.w8w_1 = unknownValue;
    this.x8w_1 = allValues;
    this.y8w_1 = PrimitiveSerialDescriptor('ShortEnumKSerializer<' + kClass.j1() + '>', SHORT_getInstance());
  }
  dz() {
    return this.y8w_1;
  }
  fz(decoder) {
    var value = decoder.e13() + 32768 | 0;
    var tmp0 = this.x8w_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.k8p() === value) {
          if (found) {
            tmp$ret$0 = null;
            break $l$block_0;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      tmp$ret$0 = single;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? this.w8w_1 : tmp0_elvis_lhs;
  }
  z8w(encoder, value) {
    var shortValue = toShort(value.k8p() - 32768 | 0);
    encoder.n14(shortValue);
  }
  ez(encoder, value) {
    return this.z8w(encoder, (!(value == null) ? value instanceof Enum ? isInterface(value, RpcInternalIndexedEnum) : false : false) ? value : THROW_CCE());
  }
}
class KrpcPluginSerializer extends RpcInternalShortEnumKSerializer {
  constructor() {
    super(getKClass(KrpcPlugin), KrpcPlugin_UNKNOWN_getInstance(), Companion_getInstance_22().j8s_1);
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_22 = this;
    this.b8s_1 = minus(toSet(get_entries_1()), KrpcPluginKey_UNKNOWN_getInstance());
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c8s_1 = lazy_0(tmp_0, KrpcPluginKey$Companion$_anonymous__1aoe3n);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_1(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class KrpcPluginKey extends Enum {
  constructor(name, ordinal, uniqueIndex, associatedPlugin) {
    super(name, ordinal);
    this.c8x_1 = uniqueIndex;
    this.d8x_1 = associatedPlugin;
    // Inline function 'kotlin.require' call
    if (!(this.w1_1 === 0 || !this.d8x_1.equals(KrpcPlugin_UNKNOWN_getInstance()))) {
      // Inline function 'kotlin.error' call
      var message = 'associatedPlugin must not be ' + toString(Companion_getInstance_22()) + '.' + toString(KrpcPlugin_UNKNOWN_getInstance()) + ' ' + ('for anything other than ' + toString(Companion_getInstance_23()) + '.UNKNOWN');
      throw IllegalStateException.o(toString(message));
    }
  }
  k8p() {
    return this.c8x_1;
  }
}
class KrpcPluginKeySerializer extends RpcInternalShortEnumKSerializer {
  constructor() {
    super(getKClass(KrpcPluginKey), KrpcPluginKey_UNKNOWN_getInstance(), Companion_getInstance_23().b8s_1);
  }
}
class MessageRequest {
  constructor(message, onMessageFailure) {
    this.e8x_1 = message;
    this.f8x_1 = onMessageFailure;
  }
  jm() {
    return this.e8x_1;
  }
  km() {
    return this.f8x_1;
  }
  toString() {
    return 'MessageRequest(message=' + toString(this.e8x_1) + ', onMessageFailure=' + toString(this.f8x_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.e8x_1);
    result = imul(result, 31) + hashCode(this.f8x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageRequest))
      return false;
    if (!equals(this.e8x_1, other.e8x_1))
      return false;
    if (!equals(this.f8x_1, other.f8x_1))
      return false;
    return true;
  }
}
class KrpcReceiveBuffer {
  constructor(bufferSize) {
    this.g8x_1 = bufferSize;
    this.h8x_1 = atomic$int$1(0);
    var tmp = this;
    tmp.i8x_1 = lazy(KrpcReceiveBuffer$_channelSize$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.j8x_1 = lazy(KrpcReceiveBuffer$channel$delegate$lambda(this));
  }
  k8x() {
    return this.h8x_1.kotlinx$atomicfu$value;
  }
  q1z() {
    var tmp0 = this.j8x_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('channel', 1, tmp, KrpcReceiveBuffer$_get_channel_$ref_fk63m(), null);
    return tmp0.k3();
  }
  *l8x($completion) {
    var result = (yield* this.q1z().o22($completion)).q21_1;
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result)) {
      this.h8x_1.atomicfu$decrementAndGet();
    }
    var tmp;
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result)) {
      tmp = new Success(ChannelResult__getOrThrow_impl_od1axs(result));
    } else if (_ChannelResult___get_isClosed__impl__mg7kuu(result)) {
      tmp = new Closed_0(ChannelResult__exceptionOrNull_impl_16ei30(result));
    } else if (_ChannelResult___get_isFailure__impl__nz6ehu(result)) {
      tmp = new Failure();
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Unreachable';
      throw IllegalStateException.o(toString(message));
    }
    return tmp;
  }
  m8x(message) {
    var result = this.q1z().k22(message);
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result)) {
      this.h8x_1.atomicfu$incrementAndGet();
    }
    var tmp;
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result)) {
      tmp = new Success(Unit_instance);
    } else if (_ChannelResult___get_isClosed__impl__mg7kuu(result)) {
      tmp = new Closed_0(ChannelResult__exceptionOrNull_impl_16ei30(result));
    } else if (_ChannelResult___get_isFailure__impl__nz6ehu(result)) {
      tmp = new Failure();
    } else {
      // Inline function 'kotlin.error' call
      var message_0 = 'Unreachable';
      throw IllegalStateException.o(toString(message_0));
    }
    return tmp;
  }
  o8q(cause) {
    this.q1z().w22(cause);
    this.q1z().n1n(CancellationException.p(null, cause));
    this.h8x_1.atomicfu$getAndSet(_get__channelSize__uesd8m(this));
  }
}
class HandlerKey {}
class Protocol {
  toString() {
    return 'Protocol';
  }
  hashCode() {
    return 127431156;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Protocol))
      return false;
    return true;
  }
}
class Generic {
  toString() {
    return 'Generic';
  }
  hashCode() {
    return 1341344507;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Generic))
      return false;
    return true;
  }
}
class Service {
  constructor(serviceType) {
    this.k8r_1 = serviceType;
  }
  toString() {
    return 'Service(serviceType=' + this.k8r_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.k8r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Service))
      return false;
    if (!(this.k8r_1 === other.k8r_1))
      return false;
    return true;
  }
}
class ServiceCall {
  constructor(serviceType, callId) {
    this.z8q_1 = serviceType;
    this.a8r_1 = callId;
  }
  toString() {
    return 'ServiceCall(serviceType=' + this.z8q_1 + ', callId=' + this.a8r_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.z8q_1);
    result = imul(result, 31) + getStringHashCode(this.a8r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ServiceCall))
      return false;
    if (!(this.z8q_1 === other.z8q_1))
      return false;
    if (!(this.a8r_1 === other.a8r_1))
      return false;
    return true;
  }
}
class KrpcStoringReceiveHandler {
  constructor(buffer, sender) {
    this.m8r_1 = buffer;
    this.n8r_1 = sender;
    this.o8r_1 = atomic$boolean$1(false);
    this.p8r_1 = atomic$boolean$1(false);
  }
  k8x() {
    return this.m8r_1.k8x();
  }
  b8r(message, onMessageFailure) {
    if (this.o8r_1.kotlinx$atomicfu$value) {
      return new Closed_0(illegalStateException('KrpcStoringReceiveHandler closed'));
    }
    return this.m8r_1.m8x(new MessageRequest(message, onMessageFailure));
  }
  p8q(key, e) {
    if (!this.o8r_1.atomicfu$compareAndSet(false, true)) {
      return Unit_instance;
    }
    this.m8r_1.q1z().w22(e);
    var tmp = _get_scope__bi2zur(this);
    var tmp_0 = CoroutineName.b1u('krpc-connector-message-buffer-close-' + toString(key));
    launch(tmp, tmp_0, VOID, KrpcStoringReceiveHandler$close$slambda(this, e));
  }
  q8r() {
    return this.p8r_1.kotlinx$atomicfu$value;
  }
  *l8x($completion) {
    if (this.o8r_1.kotlinx$atomicfu$value) {
      return new Closed_0(illegalStateException('KrpcStoringReceiveHandler closed'));
    }
    this.p8r_1.atomicfu$getAndSet(true);
    return yield* this.m8r_1.l8x($completion);
  }
}
class Success_0 {
  toString() {
    return 'Success';
  }
  hashCode() {
    return 928802428;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Success_0))
      return false;
    return true;
  }
}
class Failure_1 {
  constructor(cause) {
    this.n8x_1 = cause;
  }
  toString() {
    return 'Failure(cause=' + toString_0(this.n8x_1) + ')';
  }
  hashCode() {
    return this.n8x_1 == null ? 0 : hashCode(this.n8x_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Failure_1))
      return false;
    if (!equals(this.n8x_1, other.n8x_1))
      return false;
    return true;
  }
}
class KrpcActingReceiveHandler {
  constructor(callHandler, storingHandler, sender, key, timeout, broadcastUpdates) {
    this.o8x_1 = callHandler;
    this.p8x_1 = storingHandler;
    this.q8x_1 = sender;
    var tmp = this;
    var tmp_0 = this.q8x_1.r8r();
    var tmp_1 = CoroutineName.b1u('krpc-connector-message-handler-' + toString(key));
    var tmp_2 = CoroutineStart_LAZY_getInstance();
    tmp.r8x_1 = launch(tmp_0, tmp_1, tmp_2, KrpcActingReceiveHandler$job$slambda(this, timeout, broadcastUpdates));
    if (this.p8x_1.k8x() > 0) {
      this.r8x_1.b1n();
    }
  }
  b8r(message, onMessageFailure) {
    this.r8x_1.b1n();
    return this.p8x_1.b8r(message, onMessageFailure);
  }
  p8q(key, e) {
    if (!(e == null)) {
      if (e instanceof CancellationException) {
        this.r8x_1.n1n(e);
      } else {
        this.r8x_1.n1n(CancellationException.p(null, e));
      }
    } else {
      this.r8x_1.o1n();
    }
    this.p8x_1.p8q(key, e);
  }
  *s8x(update, connectionId, serviceType, callId, $completion) {
    var tmp0 = this.q8x_1;
    // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
    var message = new KrpcGenericMessage(connectionId, mutableMapOf([to(KrpcPluginKey_WINDOW_UPDATE_getInstance(), '' + update), to(KrpcPluginKey_WINDOW_KEY_getInstance(), serviceType + '/' + callId)]));
    try {
      yield* tmp0.g8q(message, $completion);
    } catch ($p) {
      if ($p instanceof ClosedSendChannelException) {
        var e = $p;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
}
class Success_1 {
  constructor(update, key) {
    this.t8q_1 = update;
    this.u8q_1 = key;
  }
  toString() {
    return 'Success(update=' + this.t8q_1 + ', key=' + this.u8q_1.toString() + ')';
  }
  hashCode() {
    var result = this.t8q_1;
    result = imul(result, 31) + this.u8q_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Success_1))
      return false;
    if (!(this.t8q_1 === other.t8q_1))
      return false;
    if (!this.u8q_1.equals(other.u8q_1))
      return false;
    return true;
  }
}
class Failure_2 {
  constructor(message) {
    this.s8q_1 = message;
  }
  toString() {
    return 'Failure(message=' + this.s8q_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.s8q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Failure_2))
      return false;
    if (!(this.s8q_1 === other.s8q_1))
      return false;
    return true;
  }
}
class KrpcSendHandler {
  constructor(sendChannel) {
    this.h8q_1 = sendChannel;
    this.i8q_1 = atomic$boolean$1(false);
    this.j8q_1 = -1;
    this.k8q_1 = new ReentrantLock();
    this.l8q_1 = new ReentrantLock();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.m8q_1 = ArrayList.p2();
  }
  v8q(update) {
    if (this.i8q_1.kotlinx$atomicfu$value) {
      return Unit_instance;
    }
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.k8q_1;
    var tmp = this;
    var tmp_0;
    if (this.j8q_1 === -1) {
      tmp_0 = update;
    } else {
      tmp_0 = this.j8q_1 + update | 0;
    }
    tmp.j8q_1 = tmp_0;
    if (this.j8q_1 <= 0) {
      return Unit_instance;
    }
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.l8q_1;
    var inductionVariable = 0;
    var last = this.j8q_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = removeFirstOrNull(this.m8q_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
          tmp0_safe_receiver.qd(tmp$ret$5);
        }
      }
       while (inductionVariable < last);
  }
  *n8q(message, $completion) {
    if (this.i8q_1.kotlinx$atomicfu$value) {
      throw ClosedSendChannelException.u22('KrpcSendHandler closed');
    }
    $l$loop_1: while (true) {
      var currentWindow = this.j8q_1;
      if (currentWindow === -1) {
        // Inline function 'kotlinx.coroutines.channels.onClosed' call
        var this_0 = this.h8q_1.k22(message);
        var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
        if (tmp instanceof Closed) {
          var tmp0_elvis_lhs = ChannelResult__exceptionOrNull_impl_16ei30(this_0);
          throw tmp0_elvis_lhs == null ? ClosedSendChannelException.u22('KrpcSendHandler closed') : tmp0_elvis_lhs;
        }
        break $l$loop_1;
      } else {
        if (currentWindow === 0) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
            cancellable.u1p();
            // Inline function 'kotlinx.atomicfu.locks.withLock' call
            this.k8q_1;
            $l$block: {
              if (this.j8q_1 > 0) {
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var tmp$ret$9 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.qd(tmp$ret$9);
                break $l$block;
              }
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.l8q_1;
              this.m8q_1.d2(cancellable);
            }
            return cancellable.v1p();
          });
          continue $l$loop_1;
        }
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.k8q_1;
        var tmp$ret$13;
        $l$block_0: {
          var currentWindow_0 = this.j8q_1;
          if (currentWindow_0 === 0) {
            tmp$ret$13 = false;
            break $l$block_0;
          }
          if (this.i8q_1.kotlinx$atomicfu$value) {
            throw ClosedSendChannelException.u22('KrpcSendHandler closed');
          }
          // Inline function 'kotlinx.coroutines.channels.onSuccess' call
          var this_1 = this.h8q_1.k22(message);
          var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw(this_1);
          if (!(tmp_0 instanceof Failed)) {
            _ChannelResult___get_holder__impl__pm9gzw(this_1);
            this.j8q_1 = currentWindow_0 - 1 | 0;
          }
          // Inline function 'kotlinx.coroutines.channels.onClosed' call
          var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw(this_1);
          if (tmp_1 instanceof Closed) {
            var tmp0_elvis_lhs_0 = ChannelResult__exceptionOrNull_impl_16ei30(this_1);
            throw tmp0_elvis_lhs_0 == null ? ClosedSendChannelException.u22('KrpcSendHandler closed') : tmp0_elvis_lhs_0;
          }
          var result = this_1;
          tmp$ret$13 = _ChannelResult___get_isSuccess__impl__odq1z9(result);
        }
        var sent = tmp$ret$13;
        if (sent) {
          break $l$loop_1;
        }
      }
    }
    return Unit_instance;
  }
  o8q(e) {
    if (this.i8q_1.atomicfu$compareAndSet(false, true)) {
      // Inline function 'kotlinx.atomicfu.locks.withLock' call
      this.l8q_1;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = this.m8q_1.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        element.x1q(e);
      }
    }
  }
}
class KrpcVersion extends Enum {}
class Companion_22 {
  constructor() {
    this.t8x_1 = 32768;
  }
}
class CallableParametersSerializer {
  constructor(callable, module_0) {
    this.w8x_1 = callable;
    this.x8x_1 = module_0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.w8x_1.v8n().length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = buildContextual(this.x8x_1, this.w8x_1.v8n()[tmp_3].d8o());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.y8x_1 = tmp_2;
    var tmp_4 = this;
    tmp_4.z8x_1 = buildClassSerialDescriptor('CallableParametersSerializer', [], CallableParametersSerializer$descriptor$lambda(this));
  }
  dz() {
    return this.z8x_1;
  }
  a8y(encoder, value) {
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.z8x_1;
    var composite = encoder.p13(descriptor);
    var inductionVariable = 0;
    var last = this.w8x_1.v8n().length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.g15(this.z8x_1, i, this.y8x_1[i], value[i]);
      }
       while (inductionVariable <= last);
    composite.q13(descriptor);
  }
  ez(encoder, value) {
    return this.a8y(encoder, (!(value == null) ? isArray(value) : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.z8x_1;
    var composite = decoder.p13(descriptor);
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.w8x_1.v8n().length;
    var result = Array(size);
    $l$loop: while (true) {
      var index = composite.f14(this.z8x_1);
      if (index === -1) {
        break $l$loop;
      }
      result[index] = composite.c14(this.z8x_1, index, this.y8x_1[index]);
    }
    var result_0 = result;
    composite.q13(descriptor);
    return result_0;
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b8y_1 = [null, null, lazy_0(tmp_0, SerializedException$Companion$$childSerializers$_anonymous__rqbolb), null, null];
  }
}
class $serializer_11 {
  constructor() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.SerializedException', this, 5);
    tmp0_serialDesc.h1b('toStringMessage', false);
    tmp0_serialDesc.h1b('message', false);
    tmp0_serialDesc.h1b('stacktrace', false);
    tmp0_serialDesc.h1b('cause', false);
    tmp0_serialDesc.h1b('className', false);
    this.c8y_1 = tmp0_serialDesc;
  }
  d8y(encoder, value) {
    var tmp0_desc = this.c8y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_25().b8y_1;
    tmp1_output.e15(tmp0_desc, 0, value.l8p_1);
    tmp1_output.e15(tmp0_desc, 1, value.m8p_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.n8p_1);
    tmp1_output.i15(tmp0_desc, 3, $serializer_getInstance_11(), value.o8p_1);
    tmp1_output.e15(tmp0_desc, 4, value.p8p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d8y(encoder, value instanceof SerializedException ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c8y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_25().b8y_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.d14(tmp0_desc, 3, $serializer_getInstance_11(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.z13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.d14(tmp0_desc, 3, $serializer_getInstance_11(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.z13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return SerializedException.e8y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.c8y_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_25().b8y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].k3(), get_nullable($serializer_getInstance_11()), StringSerializer_getInstance()];
  }
}
class SerializedException {
  constructor(toStringMessage, message, stacktrace, cause, className) {
    Companion_getInstance_25();
    this.l8p_1 = toStringMessage;
    this.m8p_1 = message;
    this.n8p_1 = stacktrace;
    this.o8p_1 = cause;
    this.p8p_1 = className;
  }
  toString() {
    return 'SerializedException(toStringMessage=' + this.l8p_1 + ', message=' + this.m8p_1 + ', stacktrace=' + toString(this.n8p_1) + ', cause=' + toString_0(this.o8p_1) + ', className=' + this.p8p_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l8p_1);
    result = imul(result, 31) + getStringHashCode(this.m8p_1) | 0;
    result = imul(result, 31) + hashCode(this.n8p_1) | 0;
    result = imul(result, 31) + (this.o8p_1 == null ? 0 : this.o8p_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.p8p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedException))
      return false;
    if (!(this.l8p_1 === other.l8p_1))
      return false;
    if (!(this.m8p_1 === other.m8p_1))
      return false;
    if (!equals(this.n8p_1, other.n8p_1))
      return false;
    if (!equals(this.o8p_1, other.o8p_1))
      return false;
    if (!(this.p8p_1 === other.p8p_1))
      return false;
    return true;
  }
  static e8y(seen0, toStringMessage, message, stacktrace, cause, className, serializationConstructorMarker) {
    Companion_getInstance_25();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_11().c8y_1);
    }
    var $this = createThis(this);
    $this.l8p_1 = toStringMessage;
    $this.m8p_1 = message;
    $this.n8p_1 = stacktrace;
    $this.o8p_1 = cause;
    $this.p8p_1 = className;
    return $this;
  }
}
class Companion_24 {}
class $serializer_12 {
  constructor() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.jetbrains.krpc.StackElement', this, 4);
    tmp0_serialDesc.h1b('clazz', false);
    tmp0_serialDesc.h1b('method', false);
    tmp0_serialDesc.h1b('fileName', false);
    tmp0_serialDesc.h1b('lineNumber', false);
    this.f8y_1 = tmp0_serialDesc;
  }
  g8y(encoder, value) {
    var tmp0_desc = this.f8y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.h8y_1);
    tmp1_output.e15(tmp0_desc, 1, value.i8y_1);
    tmp1_output.i15(tmp0_desc, 2, StringSerializer_getInstance(), value.j8y_1);
    tmp1_output.z14(tmp0_desc, 3, value.k8y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g8y(encoder, value instanceof StackElement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f8y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.p13(tmp0_desc);
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.d14(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.d14(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return StackElement.l8y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.f8y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance()];
  }
}
class StackElement {
  constructor(clazz, method, fileName, lineNumber) {
    this.h8y_1 = clazz;
    this.i8y_1 = method;
    this.j8y_1 = fileName;
    this.k8y_1 = lineNumber;
  }
  toString() {
    return 'StackElement(clazz=' + this.h8y_1 + ', method=' + this.i8y_1 + ', fileName=' + this.j8y_1 + ', lineNumber=' + this.k8y_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.h8y_1);
    result = imul(result, 31) + getStringHashCode(this.i8y_1) | 0;
    result = imul(result, 31) + (this.j8y_1 == null ? 0 : getStringHashCode(this.j8y_1)) | 0;
    result = imul(result, 31) + this.k8y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StackElement))
      return false;
    if (!(this.h8y_1 === other.h8y_1))
      return false;
    if (!(this.i8y_1 === other.i8y_1))
      return false;
    if (!(this.j8y_1 == other.j8y_1))
      return false;
    if (!(this.k8y_1 === other.k8y_1))
      return false;
    return true;
  }
  static l8y(seen0, clazz, method, fileName, lineNumber, serializationConstructorMarker) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_12().f8y_1);
    }
    var $this = createThis(this);
    $this.h8y_1 = clazz;
    $this.i8y_1 = method;
    $this.j8y_1 = fileName;
    $this.k8y_1 = lineNumber;
    return $this;
  }
}
class StreamSerializer {
  constructor() {
    this.m8y_1 = 'streamId';
    this.n8y_1 = 'StreamIdSerializer';
    this.o8y_1 = PrimitiveSerialDescriptor(this.n8y_1, STRING_getInstance());
  }
}
class DeserializedException extends Error {
  constructor(toStringMessage, message, stacktrace, cause, className) {
    super(null);
    setPropertiesToThrowableInstance(this, '');
    captureStack(this, this.s8y_1);
    this.p8y_1 = toStringMessage;
    this.q8y_1 = message;
    var tmp = this;
    tmp.r8y_1 = cause == null ? null : deserialize(cause);
    delete this.message;
    delete this.cause;
  }
  r() {
    return this.q8y_1;
  }
  s() {
    return this.r8y_1;
  }
  toString() {
    return this.p8y_1;
  }
  get message() {
    return this.r();
  }
  get cause() {
    return this.s();
  }
}
//endregion
function rpcClientConfig(builder) {
  var tmp;
  if (builder === VOID) {
    tmp = rpcClientConfig$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new Client();
  builder(this_0);
  return this_0.j7e();
}
function rpcClientConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function *receiveCatching(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = yield* _this__u8e3s4.d8p($completion);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var tmp$ret$0 = tmp;
  return new Result(tmp$ret$0);
}
function getOrNull_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Success) {
    tmp = _this__u8e3s4.e8p_1;
  } else {
    tmp = null;
  }
  return tmp;
}
var CancellationType_ENDPOINT_instance;
var CancellationType_SERVICE_instance;
var CancellationType_REQUEST_instance;
var CancellationType_CANCELLATION_ACK_instance;
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function values() {
  return [CancellationType_ENDPOINT_getInstance(), CancellationType_SERVICE_getInstance(), CancellationType_REQUEST_getInstance(), CancellationType_CANCELLATION_ACK_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CancellationType_entriesInitialized;
function CancellationType_initEntries() {
  if (CancellationType_entriesInitialized)
    return Unit_instance;
  CancellationType_entriesInitialized = true;
  CancellationType_ENDPOINT_instance = new CancellationType('ENDPOINT', 0, 0);
  CancellationType_SERVICE_instance = new CancellationType('SERVICE', 1, 1);
  CancellationType_REQUEST_instance = new CancellationType('REQUEST', 2, 2);
  CancellationType_CANCELLATION_ACK_instance = new CancellationType('CANCELLATION_ACK', 3, 3);
}
var $ENTRIES;
function cancellationType(_this__u8e3s4) {
  var tmp0_safe_receiver = get(_this__u8e3s4, KrpcPluginKey_CANCELLATION_TYPE_getInstance());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_instance_0.g8p(tmp0_safe_receiver);
  }
  return tmp;
}
function CancellationType_ENDPOINT_getInstance() {
  CancellationType_initEntries();
  return CancellationType_ENDPOINT_instance;
}
function CancellationType_SERVICE_getInstance() {
  CancellationType_initEntries();
  return CancellationType_SERVICE_instance;
}
function CancellationType_REQUEST_getInstance() {
  CancellationType_initEntries();
  return CancellationType_REQUEST_instance;
}
function CancellationType_CANCELLATION_ACK_getInstance() {
  CancellationType_initEntries();
  return CancellationType_CANCELLATION_ACK_instance;
}
function deserialize(_this__u8e3s4) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = deserializeUnsafe(_this__u8e3s4);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var cause = tmp;
  var tmp_1;
  if (_Result___get_isFailure__impl__jpiriv(cause)) {
    tmp_1 = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(cause));
  } else {
    // Inline function 'kotlin.Result.getOrNull' call
    var tmp$ret$4 = _Result___get_isFailure__impl__jpiriv(cause) ? null : _Result___get_value__impl__bjfvqg(cause);
    tmp_1 = ensureNotNull(tmp$ret$4);
  }
  return tmp_1;
}
function serializeException(cause) {
  var tmp0_elvis_lhs = cause.message;
  var message = tmp0_elvis_lhs == null ? 'Unknown exception' : tmp0_elvis_lhs;
  var stacktrace = stackElements(cause);
  var tmp1_safe_receiver = cause.cause;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = serializeException(tmp1_safe_receiver);
  }
  var serializedCause = tmp;
  var tmp_0;
  var tmp_1;
  if (cause instanceof CancellationException) {
    tmp_1 = true;
  } else {
    tmp_1 = cause instanceof CancellationException;
  }
  if (tmp_1) {
    var tmp2_elvis_lhs = get_rpcInternalTypeName(getKClass(CancellationException));
    tmp_0 = tmp2_elvis_lhs == null ? 'kotlinx.coroutines.CancellationException' : tmp2_elvis_lhs;
  } else {
    var tmp3_elvis_lhs = get_rpcInternalTypeName(getKClassFromExpression(cause));
    tmp_0 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  }
  var className = tmp_0;
  return new SerializedException(cause.toString(), message, stacktrace, serializedCause, className);
}
function illegalStateException(message, cause) {
  cause = cause === VOID ? null : cause;
  return cause == null ? IllegalStateException.o(message) : IllegalStateException.q(message, cause);
}
function cancellationExceptionDeserialize(_this__u8e3s4) {
  if (_this__u8e3s4.p8p_1 === get_rpcInternalTypeName(getKClass(CancellationException)) || _this__u8e3s4.p8p_1 === get_rpcInternalTypeName(getKClass(CancellationException))) {
    var tmp0_safe_receiver = _this__u8e3s4.o8p_1;
    var cause = tmp0_safe_receiver == null ? null : deserializeUnsafe(tmp0_safe_receiver);
    return CancellationException.p(_this__u8e3s4.m8p_1, cause);
  }
  return null;
}
function dump($this, $receiver) {
  var tmp;
  if ($receiver instanceof StringMessage) {
    tmp = $receiver.b8p_1;
  } else {
    if ($receiver instanceof BinaryMessage) {
      tmp = toHexString($receiver.c8p_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function _get_dumpLogger__tc8cbr($this) {
  var tmp0 = $this.e8q_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('dumpLogger', 1, tmp, KrpcConnector$_get_dumpLogger_$ref_3fja3d(), null);
  return tmp0.k3();
}
function *sendMessageIgnoreClosure($this, message, $completion) {
  // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
  try {
    yield* $this.g8q(message, $completion);
  } catch ($p) {
    if ($p instanceof ClosedSendChannelException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *sendTransportMessage($this, key, message, $completion) {
  yield* $this.z8p_1.g8l(key, KrpcConnector$sendTransportMessage$lambda($this, key)).n8q(message, $completion);
  return Unit_instance;
}
function cleanForKey($this, key) {
  var tmp0_safe_receiver = $this.z8p_1.h8l(key);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o8q(null);
  }
  var tmp1_safe_receiver = $this.w8p_1.h8l(key);
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.p8q(key, null);
  }
  $this.x8p_1.h8l(key);
}
function subscribeWithActingHandlerPerTrack($this, key, subscription) {
  var storingHandler = handlerFor($this, key);
  if (!(storingHandler instanceof KrpcStoringReceiveHandler)) {
    internalRpcError('Already subscribed to messages with key ' + toString(key));
  }
  var tmp0_callHandler = isSuspendFunction(subscription, 1) ? subscription : THROW_CCE();
  var tmp2_timeout = $this.s8p_1.x8o_1;
  var tmp3_broadcastUpdates = $this.d8q_1;
  var handler = new KrpcActingReceiveHandler(tmp0_callHandler, storingHandler, $this, key, tmp2_timeout, tmp3_broadcastUpdates);
  $this.w8p_1.e8l(key, handler);
}
function handlerFor($this, key) {
  if (key instanceof Service) {
    internalRpcError('Wrong key type for a handler: ' + toString(key));
  }
  return $this.w8p_1.g8l(key, KrpcConnector$handlerFor$lambda($this, key));
}
function decodeMessage($this, transportMessage) {
  try {
    var tmp;
    var tmp_0;
    var tmp_1 = $this.q8p_1;
    if (isInterface(tmp_1, StringFormat)) {
      tmp_0 = transportMessage instanceof StringMessage;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0 = $this.q8p_1;
      // Inline function 'kotlinx.serialization.decodeFromString' call
      var string = transportMessage.b8p_1;
      // Inline function 'kotlinx.serialization.serializer' call
      var this_0 = tmp0.l10();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_1 = serializer(this_0, createKType(getKClass(KrpcMessage), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
      tmp = tmp0.n10(tmp$ret$1, string);
    } else {
      var tmp_2;
      var tmp_3 = $this.q8p_1;
      if (isInterface(tmp_3, BinaryFormat)) {
        tmp_2 = transportMessage instanceof BinaryMessage;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        var tmp0_0 = $this.q8p_1;
        // Inline function 'kotlinx.serialization.decodeFromByteArray' call
        var bytes = transportMessage.c8p_1;
        // Inline function 'kotlinx.serialization.serializer' call
        var this_2 = tmp0_0.l10();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_3 = serializer(this_2, createKType(getKClass(KrpcMessage), arrayOf([]), false));
        var tmp$ret$4 = isInterface(this_3, KSerializer) ? this_3 : THROW_CCE();
        tmp = tmp0_0.k10(tmp$ret$4, bytes);
      } else {
        $this.v8p_1.z8l(KrpcConnector$decodeMessage$lambda($this, transportMessage));
        return null;
      }
    }
    return tmp;
  } catch ($p) {
    if ($p instanceof SerializationException) {
      var e = $p;
      $this.v8p_1.a8m(e, KrpcConnector$decodeMessage$lambda_0);
      $this.v8p_1.w8l(KrpcConnector$decodeMessage$lambda_1(transportMessage));
    } else {
      if ($p instanceof IllegalArgumentException) {
        var e_0 = $p;
        $this.v8p_1.a8m(e_0, KrpcConnector$decodeMessage$lambda_2);
        $this.v8p_1.w8l(KrpcConnector$decodeMessage$lambda_3(transportMessage));
      } else {
        throw $p;
      }
    }
  }
  return null;
}
function *processMessage($this, transportMessage, $completion) {
  var tmp0_elvis_lhs = decodeMessage($this, transportMessage);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var message = tmp;
  if (_get_dumpLogger__tc8cbr($this).c8n()) {
    var tmp_0 = _get_dumpLogger__tc8cbr($this);
    tmp_0.e8n([$this.u8p_1, 'Receive'], KrpcConnector$processMessage$lambda(transportMessage));
  }
  yield* processMessage_0($this, message, handlerKey(message), $completion);
  return Unit_instance;
}
function *processMessage_0($this, message, key, $completion) {
  if (isInterface(message, KrpcCallMessage)) {
    yield* processServiceMessage($this, message, isInterface(key, HandlerKey) ? key : THROW_CCE(), $completion);
  } else {
    var tmp;
    if (message instanceof KrpcGenericMessage) {
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = message.r8q_1;
      var tmp0 = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var key_0 = KrpcPluginKey_WINDOW_UPDATE_getInstance();
      tmp = (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).u4(key_0);
    } else {
      tmp = false;
    }
    if (tmp) {
      yield* processWindow($this, message, $completion);
    } else {
      var tmp_0;
      if (isInterface(message, KrpcProtocolMessage)) {
        tmp_0 = true;
      } else {
        tmp_0 = message instanceof KrpcGenericMessage;
      }
      if (tmp_0) {
        yield* processNonServiceMessage($this, message, key, $completion);
      } else {
        $this.v8p_1.z8l(KrpcConnector$processMessage$lambda_0(message));
      }
    }
  }
  return Unit_instance;
}
function *processWindow($this, message, $completion) {
  var result = decodeWindow(message);
  if (result instanceof Success_1) {
    var tmp0_safe_receiver = $this.z8p_1.r7c(result.u8q_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.v8q(result.t8q_1);
    }
  } else {
    if (result instanceof Failure_2) {
      yield* /*#__NOINLINE__*/sendMessageIgnoreClosure($this, new Failure_0(result.s8q_1, message.q8q_1, message), $completion);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return Unit_instance;
}
function *processNonServiceMessage($this, message, key, $completion) {
  if (message instanceof Handshake) {
    if (message.w8q_1.w2(KrpcPlugin_BACKPRESSURE_getInstance())) {
      $this.d8q_1 = true;
      $this.b8q_1 = $this.s8p_1.y8o_1;
      var tmp0_safe_receiver = message.y8q_1.w4(KrpcPluginKey_WINDOW_UPDATE_getInstance());
      var windowParam = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
      var tmp = $this;
      tmp.c8q_1 = windowParam == null ? -1 : windowParam;
    } else {
      $this.b8q_1 = 2147483647;
      $this.c8q_1 = -1;
    }
    var tmp2_safe_receiver = $this.z8p_1.r7c(Protocol_instance);
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp3_elvis_lhs = $this.c8q_1;
      tmp2_safe_receiver.v8q(tmp3_elvis_lhs == null ? -1 : tmp3_elvis_lhs);
    }
  }
  // Inline function 'kotlinx.rpc.krpc.internal.KrpcConnector.withLockForKey' call
  var tmp_0;
  var tmp_1;
  if (key instanceof ServiceCall) {
    tmp_1 = $this.u8p_1 === 'Server';
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = new Service(key.z8q_1);
  } else {
    tmp_0 = key;
  }
  var lockKey = tmp_0;
  var tmp_2;
  if (true) {
    tmp_2 = $this.x8p_1.g8l(lockKey, KrpcConnector$processNonServiceMessage$lambda);
  } else {
    tmp_2 = $this.x8p_1.r7c(lockKey);
  }
  var mutex = tmp_2;
  var tmp_3;
  if (mutex == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    yield* mutex.y2a(null, $completion);
    var tmp_4;
    try {
      var handler = handlerFor($this, key);
      tmp_4 = handler.b8r(message, KrpcConnector$processNonServiceMessage$slambda(message, key, $this));
    }finally {
      mutex.k2a(null);
    }
    tmp_3 = tmp_4;
  }
  var tmp4_safe_receiver = tmp_3;
  var tmp_5;
  if (tmp4_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlinx.rpc.krpc.internal.onFailure' call
    if (tmp4_safe_receiver instanceof Failure) {
      $l$block: {
        if (get_isException(message)) {
          break $l$block;
        }
        var tmp0_connectionId = message.c8r();
        var tmp1_errorMessage = 'Message limit of ' + $this.s8p_1.y8o_1 + ' is exceeded for ' + toString(key) + '.';
        var failure = new Failure_0(tmp1_errorMessage, tmp0_connectionId, message);
        yield* /*#__NOINLINE__*/sendMessageIgnoreClosure($this, failure, $completion);
      }
    }
    tmp_5 = tmp4_safe_receiver;
  }
  var tmp5_safe_receiver = tmp_5;
  if (tmp5_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlinx.rpc.krpc.internal.onClosed' call
    if (tmp5_safe_receiver instanceof Closed_0) {
      tmp5_safe_receiver.f8p_1;
    }
  }
  return Unit_instance;
}
function *processServiceMessage($this, message, key, $completion) {
  // Inline function 'kotlinx.rpc.krpc.internal.KrpcConnector.withLockForKey' call
  var tmp;
  var tmp_0;
  if (key instanceof ServiceCall) {
    tmp_0 = $this.u8p_1 === 'Server';
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = new Service(key.z8q_1);
  } else {
    tmp = key;
  }
  var lockKey = tmp;
  var tmp_1;
  if (true) {
    tmp_1 = $this.x8p_1.g8l(lockKey, KrpcConnector$processServiceMessage$lambda);
  } else {
    tmp_1 = $this.x8p_1.r7c(lockKey);
  }
  var mutex = tmp_1;
  var tmp_2;
  if (mutex == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    yield* mutex.y2a(null, $completion);
    var tmp_3;
    try {
      var tmp0_elvis_lhs = $this.w8p_1.r7c(key);
      var tmp_4;
      if (tmp0_elvis_lhs == null) {
        var tmp_5;
        if (Duration__isPositive_impl_tvkkt2($this.s8p_1.w8o_1)) {
          tmp_5 = handlerFor($this, key);
        } else {
          var errorMessage = 'No registered service of ' + message.d8r() + ' service type ' + ('was able to process message (' + toString(key) + ') at the moment. ') + ('Available: keys: [' + joinToString($this.w8p_1.x4()) + '].');
          yield* sendCallException($this, message, illegalStateException(errorMessage), $completion);
          return Unit_instance;
        }
        tmp_4 = tmp_5;
      } else {
        tmp_4 = tmp0_elvis_lhs;
      }
      var handler = tmp_4;
      var result = handler.b8r(message, KrpcConnector$processServiceMessage$slambda(message, $this));
      tmp_3 = to(handler, result);
    }finally {
      mutex.k2a(null);
    }
    tmp_2 = tmp_3;
  }
  var tmp0_elvis_lhs_0 = tmp_2;
  var tmp_6;
  if (tmp0_elvis_lhs_0 == null) {
    // Inline function 'kotlin.error' call
    var message_0 = 'unreachable, as we create a lock for the key';
    throw IllegalStateException.o(toString(message_0));
  } else {
    tmp_6 = tmp0_elvis_lhs_0;
  }
  var _destruct__k2r9zo = tmp_6;
  var handler_0 = _destruct__k2r9zo.jm();
  var result_0 = _destruct__k2r9zo.km();
  // Inline function 'kotlinx.rpc.krpc.internal.onFailure' call
  if (result_0 instanceof Failure) {
    $l$block: {
      if (get_isException(message)) {
        break $l$block;
      }
      yield* sendCallException($this, message, illegalStateException('Message limit of ' + $this.s8p_1.y8o_1 + ' is exceeded for ' + toString(key)), $completion);
    }
  }
  // Inline function 'kotlinx.rpc.krpc.internal.onClosed' call
  if (result_0 instanceof Closed_0) {
    result_0.f8p_1;
    $l$block_0: {
      if (get_isException(message)) {
        break $l$block_0;
      }
      yield* sendCallException($this, message, illegalStateException('Service ' + toString(key) + ' is dead'), $completion);
    }
  }
  var tmp_7;
  if (handler_0 instanceof KrpcStoringReceiveHandler) {
    // Inline function 'kotlinx.rpc.krpc.internal.isSuccess' call
    tmp_7 = result_0 instanceof Success;
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    var tmp_8 = CoroutineName.b1u('krpc-connector-discard-if-unprocessed-' + toString(key));
    launch($this.t8p_1, tmp_8, VOID, KrpcConnector$processServiceMessage$slambda_0($this, key, handler_0));
  }
  return Unit_instance;
}
function *sendCallException($this, message, cause, $completion) {
  var callException = new CallException(message.e8r(), message.d8r(), serializeException(cause), message.c8r(), message.f8r());
  yield* $this.g8q(callException, $completion);
  return Unit_instance;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function KrpcConnector$dumpLogger$delegate$lambda() {
  return RpcInternalDumpLoggerContainer_instance.f8n();
}
function KrpcConnector$_get_dumpLogger_$ref_3fja3d() {
  return constructCallableReference((p0) => _get_dumpLogger__tc8cbr(p0), 1, 0, 39);
}
function KrpcConnector$sendMessage$lambda($transportMessage) {
  return () => dump(Companion_instance_1, $transportMessage);
}
function KrpcConnector$sendTransportMessage$lambda(this$0, $key) {
  return () => {
    // Inline function 'kotlin.also' call
    var this_0 = new KrpcSendHandler(this$0.a8q_1);
    var tmp0_subject = $key;
    var tmp;
    if (equals(tmp0_subject, Protocol_instance) || equals(tmp0_subject, Generic_instance)) {
      tmp = -1;
    } else {
      var tmp1_elvis_lhs = this$0.c8q_1;
      tmp = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
    }
    var initialSize = tmp;
    this_0.v8q(initialSize);
    return this_0;
  };
}
function KrpcConnector$unsubscribeFromMessages$lambda() {
  return Mutex();
}
function KrpcConnector$unsubscribeFromMessages$lambda_0($key, this$0) {
  return (keys) => {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = keys.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp;
      if (element instanceof ServiceCall) {
        tmp = element.z8q_1 === $key.k8r_1;
      } else {
        tmp = false;
      }
      if (tmp) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      cleanForKey(this$0, element_0);
    }
    return Unit_instance;
  };
}
function KrpcConnector$subscribeToMessages$lambda() {
  return Mutex();
}
function KrpcConnector$subscribeToMessages$lambda_0($subscription) {
  return () => isSuspendFunction($subscription, 1) ? $subscription : THROW_CCE();
}
function KrpcConnector$subscribeToMessages$lambda_1($key, this$0, $subscription) {
  return (keys) => {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = keys.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp;
      if (element instanceof ServiceCall) {
        tmp = element.z8q_1 === $key.k8r_1;
      } else {
        tmp = false;
      }
      if (tmp) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      subscribeWithActingHandlerPerTrack(this$0, isInterface(element_0, HandlerKey) ? element_0 : THROW_CCE(), $subscription);
    }
    return Unit_instance;
  };
}
function KrpcConnector$handlerFor$lambda$lambda($key, this$0) {
  return () => {
    var tmp0_subject = $key;
    var tmp;
    if (equals(tmp0_subject, Protocol_instance) || equals(tmp0_subject, Generic_instance)) {
      tmp = 2147483647;
    } else {
      var tmp1_elvis_lhs = this$0.b8q_1;
      tmp = tmp1_elvis_lhs == null ? 2147483647 : tmp1_elvis_lhs;
    }
    return tmp;
  };
}
function KrpcConnector$handlerFor$lambda(this$0, $key) {
  return () => {
    var storing = new KrpcStoringReceiveHandler(new KrpcReceiveBuffer(KrpcConnector$handlerFor$lambda$lambda($key, this$0)), this$0);
    var tmp;
    var tmp_0;
    if ($key instanceof ServiceCall) {
      tmp_0 = this$0.u8p_1 === 'Server';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var serviceKey = new Service($key.z8q_1);
      var subscription = this$0.y8p_1.r7c(serviceKey);
      var tmp_1;
      if (!(subscription == null)) {
        var tmp0_callHandler = isSuspendFunction(subscription, 1) ? subscription : THROW_CCE();
        var tmp1_timeout = this$0.s8p_1.x8o_1;
        var tmp2_broadcastUpdates = this$0.d8q_1;
        tmp_1 = new KrpcActingReceiveHandler(tmp0_callHandler, storing, this$0, $key, tmp1_timeout, tmp2_broadcastUpdates);
      } else {
        tmp_1 = storing;
      }
      tmp = tmp_1;
    } else {
      tmp = storing;
    }
    return tmp;
  };
}
function KrpcConnector$drainSendQueueAndClose$lambda(this$0, $message) {
  return (it) => {
    cancel(this$0.t8p_1, $message);
    return Unit_instance;
  };
}
function KrpcConnector$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    $l$loop: while (true) {
      var tmp0_elvis_lhs = ChannelResult__getOrNull_impl_f5e07h((yield* this$0.a8q_1.o22($completion)).q21_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      yield* this$0.r8p_1.l8r(tmp, $completion);
    }
    return Unit_instance;
  }, 1);
}
function KrpcConnector$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    $l$loop: while (true) {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_0 = (yield* receiveCatching(this$0.r8p_1, $completion)).zw_1;
      var tmp0_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      yield* /*#__NOINLINE__*/processMessage(this$0, tmp, $completion);
    }
    return Unit_instance;
  }, 1);
}
function KrpcConnector$lambda(this$0) {
  return (it) => {
    this$0.w8p_1.a5();
    this$0.x8p_1.a5();
    this$0.y8p_1.a5();
    this$0.z8p_1.a5();
    return Unit_instance;
  };
}
function KrpcConnector$decodeMessage$lambda(this$0, $transportMessage) {
  return () => 'Unsupported serialization format: ' + toString(getKClassFromExpression(this$0.q8p_1)) + ' for ' + toString(getKClassFromExpression($transportMessage));
}
function KrpcConnector$decodeMessage$lambda_0() {
  return 'Failed to decode transport message';
}
function KrpcConnector$decodeMessage$lambda_1($transportMessage) {
  return () => 'Failed message: ' + dump(Companion_instance_1, $transportMessage);
}
function KrpcConnector$decodeMessage$lambda_2() {
  return 'Decoded message is not a valid ' + toString(getKClass(KrpcMessage));
}
function KrpcConnector$decodeMessage$lambda_3($transportMessage) {
  return () => 'Invalid message: ' + dump(Companion_instance_1, $transportMessage);
}
function KrpcConnector$processMessage$lambda($transportMessage) {
  return () => dump(Companion_instance_1, $transportMessage);
}
function KrpcConnector$processMessage$lambda_0($message) {
  return () => 'Received message of unknown processing: ' + toString($message);
}
function KrpcConnector$processNonServiceMessage$lambda() {
  return Mutex();
}
function KrpcConnector$processNonServiceMessage$slambda($message, $key, this$0) {
  return constructCallableReference(function *(cause, $completion) {
    var tmp;
    if (get_isException($message)) {
      return Unit_instance;
    }
    var tmp1_connectionId = $message.c8r();
    var tmp_0 = toString($key);
    var tmp2_errorMessage = 'Failed to process ' + tmp_0 + ', error: ' + (cause == null ? null : cause.message);
    var failure = new Failure_0(tmp2_errorMessage, tmp1_connectionId, $message);
    yield* /*#__NOINLINE__*/sendMessageIgnoreClosure(this$0, failure, $completion);
    return Unit_instance;
  }, 1);
}
function KrpcConnector$processServiceMessage$lambda() {
  return Mutex();
}
function KrpcConnector$processServiceMessage$slambda($message, this$0) {
  return constructCallableReference(function *(initialCause, $completion) {
    var tmp;
    if (get_isException($message)) {
      return Unit_instance;
    }
    var cause = illegalStateException('Failed to process call ' + $message.e8r() + ' for service ' + $message.d8r(), initialCause);
    yield* /*#__NOINLINE__*/sendCallException(this$0, $message, cause, $completion);
    return Unit_instance;
  }, 1);
}
function KrpcConnector$processServiceMessage$slambda$lambda() {
  return Mutex();
}
function KrpcConnector$processServiceMessage$slambda_0(this$0, $key, $handler) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.s8p_1.w8o_1, $completion);
    var tmp0 = this$0;
    // Inline function 'kotlinx.rpc.krpc.internal.KrpcConnector.withLockForKey' call
    var key = $key;
    var tmp;
    var tmp_0;
    if (key instanceof ServiceCall) {
      tmp_0 = tmp0.u8p_1 === 'Server';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new Service(key.z8q_1);
    } else {
      tmp = key;
    }
    var lockKey = tmp;
    var tmp_1;
    if (false) {
      tmp_1 = tmp0.x8p_1.g8l(lockKey, KrpcConnector$processServiceMessage$slambda$lambda);
    } else {
      tmp_1 = tmp0.x8p_1.r7c(lockKey);
    }
    var mutex = tmp_1;
    var tmp_2;
    if (mutex == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      yield* mutex.y2a(null, $completion);
      var tmp_3;
      try {
        if ($handler.q8r() || !equals(this$0.w8p_1.r7c($key), $handler)) {
          return Unit_instance;
        }
        this$0.w8p_1.h8l($key);
        tmp_3 = this$0.x8p_1.h8l($key);
      }finally {
        mutex.k2a(null);
      }
      tmp_2 = tmp_3;
    }
    $handler.p8q($key, illegalStateException('Waiting limit of ' + Duration__toString_impl_8d916b(this$0.s8p_1.w8o_1) + ' ' + ('is exceeded for unprocessed messages with ' + toString($key))));
    return Unit_instance;
  }, 1);
}
function get_isException(_this__u8e3s4) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof CallException) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof Failure_0;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function KrpcEndpoint$sendCancellation$slambda($type, $serviceId, $cancellationId, this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = to(KrpcPluginKey_GENERIC_MESSAGE_TYPE_getInstance(), 'cancellation');
    var tmp_0 = to(KrpcPluginKey_CANCELLATION_TYPE_getInstance(), toString($type));
    var tmp_1;
    if ($serviceId == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = to(KrpcPluginKey_CLIENT_SERVICE_ID_getInstance(), $serviceId);
    }
    var tmp_2 = tmp_1;
    var tmp_3;
    if ($cancellationId == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = to(KrpcPluginKey_CANCELLATION_ID_getInstance(), $cancellationId);
    }
    var message = new KrpcGenericMessage(null, toMap(listOfNotNull([tmp, tmp_0, tmp_2, tmp_3])));
    // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
    var this_0 = this$0.v8r();
    try {
      yield* this_0.g8q(message, $completion);
    } catch ($p) {
      if ($p instanceof ClosedSendChannelException) {
        var e = $p;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 1);
}
function KrpcEndpoint$sendCancellation$lambda(this$0) {
  return (it) => {
    this$0.v8r().u8r('Transport finished');
    return Unit_instance;
  };
}
function KrpcGenericMessage$Companion$$childSerializers$_anonymous__9d8z7k() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
function KrpcProtocolMessage$Handshake$Companion$$childSerializers$_anonymous__75pzc2() {
  return new LinkedHashSetSerializer(Companion_getInstance_22().a2g());
}
function KrpcProtocolMessage$Handshake$Companion$$childSerializers$_anonymous__75pzc2_0() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
function KrpcProtocolMessage$Failure$Companion$$childSerializers$_anonymous__ryzebz() {
  return Companion_instance_6.a2g();
}
function KrpcProtocolMessage$Failure$Companion$$childSerializers$_anonymous__ryzebz_0() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_4;
function Companion_getInstance_5() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  return Companion_instance_7;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.y8s_1.k3();
}
function KrpcCallMessage$CallType$Companion$_anonymous__9xv5fm() {
  var tmp = values_0();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [null, null];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [null, null];
  return createAnnotatedEnumSerializer('org.jetbrains.krpc.internal.transport.RPCMessage.CallType', tmp, tmp_0, tmp$ret$3, null);
}
var CallType_Method_instance;
var CallType_Field_instance;
function values_0() {
  return [CallType_Method_getInstance(), CallType_Field_getInstance()];
}
var Companion_instance_8;
function Companion_getInstance_9() {
  CallType_initEntries();
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
var CallType_entriesInitialized;
function CallType_initEntries() {
  if (CallType_entriesInitialized)
    return Unit_instance;
  CallType_entriesInitialized = true;
  CallType_Method_instance = new CallType('Method', 0);
  CallType_Field_instance = new CallType('Field', 1);
  Companion_getInstance_9();
}
function KrpcCallMessage$CallDataString$Companion$$childSerializers$_anonymous__qxf5qc() {
  return Companion_getInstance_9().a2g();
}
function KrpcCallMessage$CallDataString$Companion$$childSerializers$_anonymous__qxf5qc_0() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_9;
function Companion_getInstance_10() {
  if (Companion_instance_9 === VOID)
    new Companion_8();
  return Companion_instance_9;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
function KrpcCallMessage$CallDataBinary$Companion$$childSerializers$_anonymous__f2hayc() {
  return Companion_getInstance_9().a2g();
}
function KrpcCallMessage$CallDataBinary$Companion$$childSerializers$_anonymous__f2hayc_0() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_10;
function Companion_getInstance_11() {
  if (Companion_instance_10 === VOID)
    new Companion_9();
  return Companion_instance_10;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new $serializer_3();
  return $serializer_instance_3;
}
var Companion_instance_11;
function Companion_getInstance_12() {
  return Companion_instance_11;
}
function KrpcCallMessage$CallSuccessString$Companion$$childSerializers$_anonymous__vs64gn() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_12;
function Companion_getInstance_13() {
  if (Companion_instance_12 === VOID)
    new Companion_11();
  return Companion_instance_12;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new $serializer_4();
  return $serializer_instance_4;
}
function KrpcCallMessage$CallSuccessBinary$Companion$$childSerializers$_anonymous__jx89on() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_13;
function Companion_getInstance_14() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new $serializer_5();
  return $serializer_instance_5;
}
function KrpcCallMessage$CallException$Companion$$childSerializers$_anonymous__kkmq6m() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_14;
function Companion_getInstance_15() {
  if (Companion_instance_14 === VOID)
    new Companion_13();
  return Companion_instance_14;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new $serializer_6();
  return $serializer_instance_6;
}
var Companion_instance_15;
function Companion_getInstance_16() {
  return Companion_instance_15;
}
function KrpcCallMessage$StreamMessageString$Companion$$childSerializers$_anonymous__ceqgsn() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_16;
function Companion_getInstance_17() {
  if (Companion_instance_16 === VOID)
    new Companion_15();
  return Companion_instance_16;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new $serializer_7();
  return $serializer_instance_7;
}
function KrpcCallMessage$StreamMessageBinary$Companion$$childSerializers$_anonymous__o9obkn() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_17;
function Companion_getInstance_18() {
  if (Companion_instance_17 === VOID)
    new Companion_16();
  return Companion_instance_17;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new $serializer_8();
  return $serializer_instance_8;
}
function KrpcCallMessage$StreamCancel$Companion$$childSerializers$_anonymous__8dkz0b() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_18;
function Companion_getInstance_19() {
  if (Companion_instance_18 === VOID)
    new Companion_17();
  return Companion_instance_18;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new $serializer_9();
  return $serializer_instance_9;
}
function KrpcCallMessage$StreamFinished$Companion$$childSerializers$_anonymous__grebnh() {
  return new LinkedHashMapSerializer(Companion_getInstance_23().a2g(), StringSerializer_getInstance());
}
var Companion_instance_19;
function Companion_getInstance_20() {
  if (Companion_instance_19 === VOID)
    new Companion_18();
  return Companion_instance_19;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new $serializer_10();
  return $serializer_instance_10;
}
var Companion_instance_20;
function Companion_getInstance_21() {
  return Companion_instance_20;
}
function CallType_Method_getInstance() {
  CallType_initEntries();
  return CallType_Method_instance;
}
function CallType_Field_getInstance() {
  CallType_initEntries();
  return CallType_Field_instance;
}
function get(_this__u8e3s4, key) {
  var tmp0_safe_receiver = _this__u8e3s4.i8s();
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(key);
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.k8s_1.k3();
}
function KrpcPlugin$Companion$_anonymous__1hzj8e() {
  return new KrpcPluginSerializer();
}
var KrpcPlugin_UNKNOWN_instance;
var KrpcPlugin_HANDSHAKE_instance;
var KrpcPlugin_CANCELLATION_instance;
var KrpcPlugin_NON_SUSPENDING_SERVER_FLOWS_instance;
var KrpcPlugin_NO_ACK_CANCELLATION_instance;
var KrpcPlugin_BACKPRESSURE_instance;
var Companion_instance_21;
function Companion_getInstance_22() {
  KrpcPlugin_initEntries();
  if (Companion_instance_21 === VOID)
    new Companion_20();
  return Companion_instance_21;
}
function values_1() {
  return [KrpcPlugin_UNKNOWN_getInstance(), KrpcPlugin_HANDSHAKE_getInstance(), KrpcPlugin_CANCELLATION_getInstance(), KrpcPlugin_NON_SUSPENDING_SERVER_FLOWS_getInstance(), KrpcPlugin_NO_ACK_CANCELLATION_getInstance(), KrpcPlugin_BACKPRESSURE_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_1());
  return $ENTRIES_0;
}
var KrpcPlugin_entriesInitialized;
function KrpcPlugin_initEntries() {
  if (KrpcPlugin_entriesInitialized)
    return Unit_instance;
  KrpcPlugin_entriesInitialized = true;
  KrpcPlugin_UNKNOWN_instance = new KrpcPlugin('UNKNOWN', 0, 0, KrpcVersion_V_0_1_0_BETA_getInstance());
  KrpcPlugin_HANDSHAKE_instance = new KrpcPlugin('HANDSHAKE', 1, 1, KrpcVersion_V_0_1_0_BETA_getInstance());
  KrpcPlugin_CANCELLATION_instance = new KrpcPlugin('CANCELLATION', 2, 2, KrpcVersion_V_0_1_0_BETA_getInstance());
  KrpcPlugin_NON_SUSPENDING_SERVER_FLOWS_instance = new KrpcPlugin('NON_SUSPENDING_SERVER_FLOWS', 3, 3, KrpcVersion_V_0_6_0_getInstance());
  KrpcPlugin_NO_ACK_CANCELLATION_instance = new KrpcPlugin('NO_ACK_CANCELLATION', 4, 4, KrpcVersion_V_0_8_0_getInstance());
  KrpcPlugin_BACKPRESSURE_instance = new KrpcPlugin('BACKPRESSURE', 5, 5, KrpcVersion_V_0_10_0_getInstance());
  Companion_getInstance_22();
}
var $ENTRIES_0;
function KrpcPlugin_UNKNOWN_getInstance() {
  KrpcPlugin_initEntries();
  return KrpcPlugin_UNKNOWN_instance;
}
function KrpcPlugin_HANDSHAKE_getInstance() {
  KrpcPlugin_initEntries();
  return KrpcPlugin_HANDSHAKE_instance;
}
function KrpcPlugin_CANCELLATION_getInstance() {
  KrpcPlugin_initEntries();
  return KrpcPlugin_CANCELLATION_instance;
}
function KrpcPlugin_NON_SUSPENDING_SERVER_FLOWS_getInstance() {
  KrpcPlugin_initEntries();
  return KrpcPlugin_NON_SUSPENDING_SERVER_FLOWS_instance;
}
function KrpcPlugin_NO_ACK_CANCELLATION_getInstance() {
  KrpcPlugin_initEntries();
  return KrpcPlugin_NO_ACK_CANCELLATION_instance;
}
function KrpcPlugin_BACKPRESSURE_getInstance() {
  KrpcPlugin_initEntries();
  return KrpcPlugin_BACKPRESSURE_instance;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.c8s_1.k3();
}
function KrpcPluginKey$Companion$_anonymous__1aoe3n() {
  return new KrpcPluginKeySerializer();
}
var KrpcPluginKey_UNKNOWN_instance;
var KrpcPluginKey_GENERIC_MESSAGE_TYPE_instance;
var KrpcPluginKey_CANCELLATION_TYPE_instance;
var KrpcPluginKey_CANCELLATION_ID_instance;
var KrpcPluginKey_CLIENT_SERVICE_ID_instance;
var KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_instance;
var KrpcPluginKey_WINDOW_UPDATE_instance;
var KrpcPluginKey_WINDOW_KEY_instance;
var Companion_instance_22;
function Companion_getInstance_23() {
  KrpcPluginKey_initEntries();
  if (Companion_instance_22 === VOID)
    new Companion_21();
  return Companion_instance_22;
}
function values_2() {
  return [KrpcPluginKey_UNKNOWN_getInstance(), KrpcPluginKey_GENERIC_MESSAGE_TYPE_getInstance(), KrpcPluginKey_CANCELLATION_TYPE_getInstance(), KrpcPluginKey_CANCELLATION_ID_getInstance(), KrpcPluginKey_CLIENT_SERVICE_ID_getInstance(), KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance(), KrpcPluginKey_WINDOW_UPDATE_getInstance(), KrpcPluginKey_WINDOW_KEY_getInstance()];
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_2());
  return $ENTRIES_1;
}
var KrpcPluginKey_entriesInitialized;
function KrpcPluginKey_initEntries() {
  if (KrpcPluginKey_entriesInitialized)
    return Unit_instance;
  KrpcPluginKey_entriesInitialized = true;
  KrpcPluginKey_UNKNOWN_instance = new KrpcPluginKey('UNKNOWN', 0, 0, KrpcPlugin_UNKNOWN_getInstance());
  KrpcPluginKey_GENERIC_MESSAGE_TYPE_instance = new KrpcPluginKey('GENERIC_MESSAGE_TYPE', 1, 1, KrpcPlugin_HANDSHAKE_getInstance());
  KrpcPluginKey_CANCELLATION_TYPE_instance = new KrpcPluginKey('CANCELLATION_TYPE', 2, 2, KrpcPlugin_CANCELLATION_getInstance());
  KrpcPluginKey_CANCELLATION_ID_instance = new KrpcPluginKey('CANCELLATION_ID', 3, 3, KrpcPlugin_CANCELLATION_getInstance());
  KrpcPluginKey_CLIENT_SERVICE_ID_instance = new KrpcPluginKey('CLIENT_SERVICE_ID', 4, 4, KrpcPlugin_CANCELLATION_getInstance());
  KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_instance = new KrpcPluginKey('NON_SUSPENDING_SERVER_FLOW_MARKER', 5, 5, KrpcPlugin_NON_SUSPENDING_SERVER_FLOWS_getInstance());
  KrpcPluginKey_WINDOW_UPDATE_instance = new KrpcPluginKey('WINDOW_UPDATE', 6, 6, KrpcPlugin_BACKPRESSURE_getInstance());
  KrpcPluginKey_WINDOW_KEY_instance = new KrpcPluginKey('WINDOW_KEY', 7, 7, KrpcPlugin_BACKPRESSURE_getInstance());
  Companion_getInstance_23();
}
var $ENTRIES_1;
function KrpcPluginKey_UNKNOWN_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_UNKNOWN_instance;
}
function KrpcPluginKey_GENERIC_MESSAGE_TYPE_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_GENERIC_MESSAGE_TYPE_instance;
}
function KrpcPluginKey_CANCELLATION_TYPE_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_CANCELLATION_TYPE_instance;
}
function KrpcPluginKey_CANCELLATION_ID_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_CANCELLATION_ID_instance;
}
function KrpcPluginKey_CLIENT_SERVICE_ID_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_CLIENT_SERVICE_ID_instance;
}
function KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_instance;
}
function KrpcPluginKey_WINDOW_UPDATE_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_WINDOW_UPDATE_instance;
}
function KrpcPluginKey_WINDOW_KEY_getInstance() {
  KrpcPluginKey_initEntries();
  return KrpcPluginKey_WINDOW_KEY_instance;
}
function _get__channelSize__uesd8m($this) {
  var tmp0 = $this.i8x_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_channelSize', 1, tmp, KrpcReceiveBuffer$_get__channelSize_$ref_mc6p3k(), null);
  return tmp0.k3();
}
function KrpcReceiveBuffer$_channelSize$delegate$lambda(this$0) {
  return () => this$0.g8x_1();
}
function KrpcReceiveBuffer$_get__channelSize_$ref_mc6p3k() {
  return constructCallableReference((p0) => _get__channelSize__uesd8m(p0), 1, 0, 40);
}
function KrpcReceiveBuffer$channel$delegate$lambda(this$0) {
  return () => Channel(_get__channelSize__uesd8m(this$0));
}
function KrpcReceiveBuffer$_get_channel_$ref_fk63m() {
  return constructCallableReference((p0) => p0.q1z(), 1, 0, 41);
}
var Protocol_instance;
function Protocol_getInstance() {
  return Protocol_instance;
}
var Generic_instance;
function Generic_getInstance() {
  return Generic_instance;
}
function handlerKey(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, KrpcCallMessage)) {
    tmp = new ServiceCall(_this__u8e3s4.d8r(), _this__u8e3s4.e8r());
  } else {
    if (isInterface(_this__u8e3s4, KrpcProtocolMessage)) {
      tmp = Protocol_instance;
    } else {
      if (_this__u8e3s4 instanceof KrpcGenericMessage) {
        tmp = Generic_instance;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unreachable';
        throw IllegalStateException.o(toString(message));
      }
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, HandlerKey) ? tmp_0 : THROW_CCE();
}
function _get_scope__bi2zur($this) {
  return $this.n8r_1.r8r();
}
function KrpcStoringReceiveHandler$close$slambda(this$0, $e) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var allLeft = ArrayList.p2();
    $l$loop: while (true) {
      var result = this$0.m8r_1.q1z().p22();
      if (_ChannelResult___get_isClosed__impl__mg7kuu(result) || _ChannelResult___get_isFailure__impl__nz6ehu(result)) {
        break $l$loop;
      }
      allLeft.d2(ChannelResult__getOrThrow_impl_od1axs(result).e8x_1);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = allLeft.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element == null) ? isInterface(element, KrpcCallMessage) : false) {
        destination.d2(element);
      }
    }
    var undelivered = destination;
    var tmp;
    if (undelivered.n1()) {
      this$0.m8r_1.o8q($e);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap.m7();
    var _iterator__ex2g4s_0 = undelivered.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var key = element_0.e8r();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_0.w4(key);
      var tmp_0;
      if (value == null) {
        var answer = ArrayList.p2();
        destination_0.b5(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.d2(element_0);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = destination_0.i3().p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_1 = _iterator__ex2g4s_1.r1();
      // Inline function 'kotlin.collections.component1' call
      var callId = element_1.j3();
      // Inline function 'kotlin.collections.component2' call
      var messages = element_1.k3();
      var message = first(messages);
      var cause = illegalStateException('Buffer closed for ' + callId + ' for service ' + message.d8r() + ', ' + ('' + messages.s2() + ' messages were unprocessed'), $e);
      var callException = new CallException(message.e8r(), message.d8r(), serializeException(cause), message.c8r(), message.f8r());
      // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
      var this_0 = this$0.n8r_1;
      try {
        yield* this_0.g8q(callException, $completion);
      } catch ($p) {
        if ($p instanceof ClosedSendChannelException) {
          var e = $p;
        } else {
          throw $p;
        }
      }
    }
    this$0.m8r_1.o8q($e);
    return Unit_instance;
  }, 1);
}
var Success_instance;
function Success_getInstance() {
  return Success_instance;
}
function *tryHandle($this, message, $completion) {
  try {
    yield* $this.o8x_1(message, $completion);
    return Success_instance;
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        return new Failure_1(e_0);
      } else {
        throw $p;
      }
    }
  }
}
function KrpcActingReceiveHandler$job$slambda$slambda(this$0, $message) {
  return constructCallableReference(function *($this$withTimeoutOrNull, $completion) {
    return yield* /*#__NOINLINE__*/tryHandle(this$0, $message, $completion);
  }, 1);
}
function KrpcActingReceiveHandler$job$slambda(this$0, $timeout, $broadcastUpdates) {
  return constructCallableReference(function *($this$launch, $completion) {
    $l$loop_0: while (true) {
      var tmp0_elvis_lhs = getOrNull_0(yield* this$0.p8x_1.l8x($completion));
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var _destruct__k2r9zo = tmp;
      var message = _destruct__k2r9zo.jm();
      var onMessageFailure = _destruct__k2r9zo.km();
      var tmp_0;
      if (equals($timeout, Companion_getInstance().kk_1)) {
        tmp_0 = yield* /*#__NOINLINE__*/tryHandle(this$0, message, $completion);
      } else {
        var tmp1_elvis_lhs = yield* withTimeoutOrNull($timeout, KrpcActingReceiveHandler$job$slambda$slambda(this$0, message), $completion);
        tmp_0 = tmp1_elvis_lhs == null ? new Failure_1(illegalStateException('Timeout while processing message')) : tmp1_elvis_lhs;
      }
      var result = tmp_0;
      if (result instanceof Failure_1) {
        yield* onMessageFailure(result.n8x_1, $completion);
      }
      if (!isInterface(message, KrpcCallMessage))
        continue $l$loop_0;
      if ($broadcastUpdates) {
        yield* this$0.s8x(1, message.c8r(), message.d8r(), message.e8r(), $completion);
      }
    }
    return Unit_instance;
  }, 1);
}
function decodeWindow(message) {
  var tmp0_safe_receiver = message.r8q_1;
  var windowParam = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(KrpcPluginKey_WINDOW_UPDATE_getInstance());
  // Inline function 'kotlin.text.isNullOrEmpty' call
  if (windowParam == null || charSequenceLength(windowParam) === 0) {
    return new Failure_2('Window param must be of the form <available>/<windowId>');
  }
  var tmp1_elvis_lhs = toIntOrNull(windowParam);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return new Failure_2('Window param must be of the form <available>/<windowId> and in form of two longs');
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var updateParam = tmp;
  var tmp2_safe_receiver = message.r8q_1.w4(KrpcPluginKey_WINDOW_KEY_getInstance());
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : split(tmp2_safe_receiver, ['/']);
  var windowKey = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  var serviceType = getOrNull(windowKey, 0);
  var callId = getOrNull(windowKey, 1);
  if (!(windowKey.s2() === 2) || serviceType == null || callId == null) {
    return new Failure_2('Window key must be of the form <serviceType>/<callId>');
  }
  var subscriptionKey = new ServiceCall(serviceType, callId);
  return new Success_1(updateParam, subscriptionKey);
}
var KrpcVersion_V_0_1_0_BETA_instance;
var KrpcVersion_V_0_6_0_instance;
var KrpcVersion_V_0_8_0_instance;
var KrpcVersion_V_0_10_0_instance;
var KrpcVersion_entriesInitialized;
function KrpcVersion_initEntries() {
  if (KrpcVersion_entriesInitialized)
    return Unit_instance;
  KrpcVersion_entriesInitialized = true;
  KrpcVersion_V_0_1_0_BETA_instance = new KrpcVersion('V_0_1_0_BETA', 0);
  KrpcVersion_V_0_6_0_instance = new KrpcVersion('V_0_6_0', 1);
  KrpcVersion_V_0_8_0_instance = new KrpcVersion('V_0_8_0', 2);
  KrpcVersion_V_0_10_0_instance = new KrpcVersion('V_0_10_0', 3);
}
function KrpcVersion_V_0_1_0_BETA_getInstance() {
  KrpcVersion_initEntries();
  return KrpcVersion_V_0_1_0_BETA_instance;
}
function KrpcVersion_V_0_6_0_getInstance() {
  KrpcVersion_initEntries();
  return KrpcVersion_V_0_6_0_instance;
}
function KrpcVersion_V_0_8_0_getInstance() {
  KrpcVersion_initEntries();
  return KrpcVersion_V_0_8_0_instance;
}
function KrpcVersion_V_0_10_0_getInstance() {
  KrpcVersion_initEntries();
  return KrpcVersion_V_0_10_0_instance;
}
function rpcInternalObjectId(_this__u8e3s4, tags) {
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(tags.length === 0)) {
    tmp = tags;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    tmp_0 = joinToString_0(tmp0_safe_receiver, VOID, VOID, VOID, VOID, VOID, rpcInternalObjectId$lambda);
  }
  var tmp1_elvis_lhs = tmp_0;
  var tagsString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  return '' + getKClassFromExpression(_this__u8e3s4).j1() + tagsString + '[' + toString_1(hashCode(_this__u8e3s4), 16) + ']';
}
function rpcInternalObjectId$lambda(it) {
  return '[' + it + ']';
}
var Companion_instance_23;
function Companion_getInstance_24() {
  return Companion_instance_23;
}
function buildContextual(_this__u8e3s4, type) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = type.z11();
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof Serializable) {
      destination.d2(element);
    }
  }
  var tmp0_safe_receiver = lastOrNull(destination);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = type instanceof RpcTypeKrpc ? type : null;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      var tmp0_0 = tmp0_safe_receiver_0.u8x_1;
      // Inline function 'kotlin.collections.get' call
      var key = tmp0_safe_receiver.v8x_1;
      tmp_0 = (isInterface(tmp0_0, KtMap) ? tmp0_0 : THROW_CCE()).w4(key);
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? buildContextual_0(_this__u8e3s4, type.y8n()) : tmp1_elvis_lhs;
}
function decodeMessageData(serialFormat, dataSerializer, data) {
  var tmp;
  if (isInterface(serialFormat, StringFormat)) {
    if (!isInterface(data, StringData)) {
      unexpectedDataFormatForProvidedSerialFormat(data, false);
    }
    tmp = serialFormat.n10(dataSerializer, data.x8s());
  } else {
    if (isInterface(serialFormat, BinaryFormat)) {
      if (!isInterface(data, BinaryData)) {
        unexpectedDataFormatForProvidedSerialFormat(data, true);
      }
      tmp = serialFormat.k10(dataSerializer, data.x8s());
    } else {
      unsupportedSerialFormatError(serialFormat);
    }
  }
  return tmp;
}
function CallableParametersSerializer$descriptor$lambda(this$0) {
  return ($this$buildClassSerialDescriptor) => {
    var inductionVariable = 0;
    var last = this$0.y8x_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var param = this$0.w8x_1.v8n()[i];
        $this$buildClassSerialDescriptor.l12(param.h1(), this$0.y8x_1[i].dz(), param.d8o().z11(), param.e8o());
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function unsupportedSerialFormatError(serialFormat) {
  // Inline function 'kotlin.error' call
  var message = 'Unsupported serial format ' + toString(getKClassFromExpression(serialFormat)) + ', only StringFormat and BinaryFormats are supported';
  throw IllegalStateException.o(toString(message));
}
function buildContextual_0(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = buildContextualInternal(_this__u8e3s4, type);
  return tmp0_elvis_lhs == null ? serializer(_this__u8e3s4, type) : tmp0_elvis_lhs;
}
function unexpectedDataFormatForProvidedSerialFormat(data, shouldBeBinary) {
  var _destruct__k2r9zo = shouldBeBinary ? to('BinaryFormat', 'string') : to('StringFormat', 'binary');
  var expected = _destruct__k2r9zo.jm();
  var actual = _destruct__k2r9zo.km();
  // Inline function 'kotlin.error' call
  var message = 'Unexpected message format for provided serial format: ' + ('message is in ' + actual + ' format (' + toString(getKClassFromExpression(data)) + '), but provided SerialFormat is ' + expected);
  throw IllegalStateException.o(toString(message));
}
function buildContextualInternal(_this__u8e3s4, type) {
  var tmp = rpcInternalKClass(type);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = type.f1();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var i = checkIndexOverflow(_unary__edvuaz);
    var tmp0_elvis_lhs = item.ft_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Unexpected star projection type at index ' + i + " in type arguments list of '" + toString(type) + "'";
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var typeArg = tmp_0;
    var tmp1_elvis_lhs = buildContextualInternal(_this__u8e3s4, typeArg);
    var tmp$ret$2 = tmp1_elvis_lhs == null ? serializer(_this__u8e3s4, typeArg) : tmp1_elvis_lhs;
    destination.d2(tmp$ret$2);
  }
  var result = _this__u8e3s4.m11(tmp, destination);
  var tmp_1;
  if (type.g1()) {
    tmp_1 = result == null ? null : get_nullable(result);
  } else {
    tmp_1 = (!(result == null) ? isInterface(result, KSerializer) : false) ? result : null;
  }
  return tmp_1;
}
function SerializedException$Companion$$childSerializers$_anonymous__rqbolb() {
  return new ArrayListSerializer($serializer_getInstance_12());
}
var Companion_instance_24;
function Companion_getInstance_25() {
  if (Companion_instance_24 === VOID)
    new Companion_23();
  return Companion_instance_24;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new $serializer_11();
  return $serializer_instance_11;
}
var Companion_instance_25;
function Companion_getInstance_26() {
  return Companion_instance_25;
}
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 === VOID)
    new $serializer_12();
  return $serializer_instance_12;
}
function deserializeUnsafe(_this__u8e3s4) {
  var tmp0_elvis_lhs = cancellationExceptionDeserialize(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? new DeserializedException(_this__u8e3s4.l8p_1, _this__u8e3s4.m8p_1, _this__u8e3s4.n8p_1, _this__u8e3s4.o8p_1, _this__u8e3s4.p8p_1) : tmp0_elvis_lhs;
}
function stackElements(_this__u8e3s4) {
  return emptyList();
}
//region block: post-declaration
initMetadataForClass(Connector, 'Connector', Connector);
initMetadataForClass(KrpcConfigBuilder, 'KrpcConfigBuilder');
initMetadataForClass(Client, 'Client', Client);
initMetadataForClass(KrpcConfigBuilder$configuration$1);
initMetadataForClass(Connector_0, 'Connector');
initMetadataForClass(Client_0, 'Client');
initMetadataForClass(StringMessage, 'StringMessage');
initMetadataForClass(BinaryMessage, 'BinaryMessage');
initMetadataForClass(Success, 'Success');
initMetadataForClass(Failure, 'Failure', Failure);
initMetadataForClass(Closed_0, 'Closed');
initMetadataForCompanion(Companion);
initMetadataForInterface(RpcInternalIndexedEnum, 'RpcInternalIndexedEnum');
initMetadataForClass(CancellationType, 'CancellationType', VOID, VOID, [RpcInternalIndexedEnum]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KrpcConnector, 'KrpcConnector', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForInterface(KrpcEndpoint, 'KrpcEndpoint', VOID, VOID, VOID, [1]);
initMetadataForCompanion(Companion_1);
protoOf($serializer).z1b = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(KrpcMessage, 'KrpcMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
initMetadataForClass(KrpcGenericMessage, 'KrpcGenericMessage', VOID, VOID, [KrpcMessage], VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_2);
protoOf($serializer_0).z1b = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_3);
protoOf($serializer_1).z1b = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(KrpcProtocolMessage, 'KrpcProtocolMessage', VOID, VOID, [KrpcMessage], VOID, VOID, {0: Companion_getInstance_6});
initMetadataForClass(Handshake, 'Handshake', VOID, VOID, [KrpcProtocolMessage], VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForClass(Failure_0, 'Failure', VOID, VOID, [KrpcProtocolMessage], VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_4, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_5, VOID, [SerializerFactory]);
initMetadataForInterface(BinaryData, 'BinaryData');
initMetadataForInterface(StringData, 'StringData');
initMetadataForCompanion(Companion_6, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_7, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_8);
protoOf($serializer_2).z1b = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_9);
protoOf($serializer_3).z1b = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_10, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_11);
protoOf($serializer_4).z1b = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_12);
protoOf($serializer_5).z1b = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_13);
protoOf($serializer_6).z1b = typeParametersSerializers;
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_14, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_15);
protoOf($serializer_7).z1b = typeParametersSerializers;
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_16);
protoOf($serializer_8).z1b = typeParametersSerializers;
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_17);
protoOf($serializer_9).z1b = typeParametersSerializers;
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_18);
protoOf($serializer_10).z1b = typeParametersSerializers;
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(KrpcCallMessage, 'KrpcCallMessage', VOID, VOID, [KrpcMessage], VOID, VOID, {0: Companion_getInstance_21});
initMetadataForInterface(CallData, 'CallData', VOID, VOID, [KrpcCallMessage], VOID, VOID, {0: Companion_getInstance_8});
initMetadataForClass(CallType, 'CallType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
initMetadataForClass(CallDataString, 'CallDataString', VOID, VOID, [CallData, StringData], VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForClass(CallDataBinary, 'CallDataBinary', VOID, VOID, [CallData, BinaryData], VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForInterface(CallSuccess, 'CallSuccess', VOID, VOID, [KrpcCallMessage], VOID, VOID, {0: Companion_getInstance_12});
initMetadataForClass(CallSuccessString, 'CallSuccessString', VOID, VOID, [CallSuccess, StringData], VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForClass(CallSuccessBinary, 'CallSuccessBinary', VOID, VOID, [CallSuccess, BinaryData], VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForClass(CallException, 'CallException', VOID, VOID, [KrpcCallMessage], VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForInterface(StreamMessage, 'StreamMessage', VOID, VOID, [KrpcCallMessage], VOID, VOID, {0: Companion_getInstance_16});
initMetadataForClass(StreamMessageString, 'StreamMessageString', VOID, VOID, [StreamMessage, StringData], VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForClass(StreamMessageBinary, 'StreamMessageBinary', VOID, VOID, [StreamMessage, BinaryData], VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForClass(StreamCancel, 'StreamCancel', VOID, VOID, [KrpcCallMessage], VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForClass(StreamFinished, 'StreamFinished', VOID, VOID, [KrpcCallMessage], VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_19, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_20, VOID, [SerializerFactory]);
initMetadataForClass(KrpcPlugin, 'KrpcPlugin', VOID, VOID, [RpcInternalIndexedEnum], VOID, VOID, {0: Companion_getInstance_22});
initMetadataForClass(RpcInternalShortEnumKSerializer, 'RpcInternalShortEnumKSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(KrpcPluginSerializer, 'KrpcPluginSerializer', KrpcPluginSerializer);
initMetadataForCompanion(Companion_21, VOID, [SerializerFactory]);
initMetadataForClass(KrpcPluginKey, 'KrpcPluginKey', VOID, VOID, [RpcInternalIndexedEnum], VOID, VOID, {0: Companion_getInstance_23});
initMetadataForClass(KrpcPluginKeySerializer, 'KrpcPluginKeySerializer', KrpcPluginKeySerializer);
initMetadataForClass(MessageRequest, 'MessageRequest');
initMetadataForClass(KrpcReceiveBuffer, 'KrpcReceiveBuffer', VOID, VOID, VOID, [0]);
initMetadataForInterface(HandlerKey, 'HandlerKey');
initMetadataForObject(Protocol, 'Protocol', VOID, VOID, [HandlerKey]);
initMetadataForObject(Generic, 'Generic', VOID, VOID, [HandlerKey]);
initMetadataForClass(Service, 'Service', VOID, VOID, [HandlerKey]);
initMetadataForClass(ServiceCall, 'ServiceCall', VOID, VOID, [HandlerKey]);
initMetadataForClass(KrpcStoringReceiveHandler, 'KrpcStoringReceiveHandler', VOID, VOID, VOID, [0]);
initMetadataForObject(Success_0, 'Success');
initMetadataForClass(Failure_1, 'Failure');
initMetadataForClass(KrpcActingReceiveHandler, 'KrpcActingReceiveHandler', VOID, VOID, VOID, [1, 4]);
initMetadataForClass(Success_1, 'Success');
initMetadataForClass(Failure_2, 'Failure');
initMetadataForClass(KrpcSendHandler, 'KrpcSendHandler', VOID, VOID, VOID, [1]);
initMetadataForClass(KrpcVersion, 'KrpcVersion');
initMetadataForCompanion(Companion_22);
initMetadataForClass(CallableParametersSerializer, 'CallableParametersSerializer', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_23);
protoOf($serializer_11).z1b = typeParametersSerializers;
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SerializedException, 'SerializedException', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_24);
protoOf($serializer_12).z1b = typeParametersSerializers;
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StackElement, 'StackElement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForClass(StreamSerializer, 'StreamSerializer');
initMetadataForClass(DeserializedException, 'DeserializedException');
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_1 = new Companion_0();
Companion_instance_5 = new Companion_4();
Companion_instance_6 = new Companion_5();
Companion_instance_7 = new Companion_6();
Companion_instance_11 = new Companion_10();
Companion_instance_15 = new Companion_14();
Companion_instance_20 = new Companion_19();
Protocol_instance = new Protocol();
Generic_instance = new Generic();
Success_instance = new Success_0();
Companion_instance_23 = new Companion_22();
Companion_instance_25 = new Companion_24();
//endregion
//region block: exports
export {
  Generic_instance as Generic_instance1ic2aqjydnzrh,
  Protocol_instance as Protocol_instance2ojjlc2yk2h1r,
  Companion_getInstance_22 as Companion_getInstance2t6whcwokm4cc,
  CancellationType_ENDPOINT_getInstance as CancellationType_ENDPOINT_getInstance6iufvg18q1fp,
  CancellationType_REQUEST_getInstance as CancellationType_REQUEST_getInstance4vacwxnpf4yu,
  CallType_Method_getInstance as CallType_Method_getInstance2dbh40ur48cef,
  KrpcPluginKey_CANCELLATION_TYPE_getInstance as KrpcPluginKey_CANCELLATION_TYPE_getInstance3keaurjiu7uwn,
  KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance as KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance23127b0ayxu6x,
  handleGenericMessage as handleGenericMessage1qkadapt8s9wk,
  sendCancellation$default as sendCancellation$default3ne1rl72wh1kl,
  CallableParametersSerializer as CallableParametersSerializer1k5n8tzz1b8bg,
  ServiceCall as ServiceCall2c26s9o99x7xs,
  CallDataBinary as CallDataBinaryupe51whtnnt5,
  CallDataString as CallDataString54rlcd0zej8o,
  CallData as CallDatate73dsq212t6,
  CallException as CallExceptionqh88lj8kp459,
  CallSuccess as CallSuccess2l9ustajavsnp,
  StreamCancel as StreamCancel1cxd0d8l4r06h,
  StreamFinished as StreamFinished17y6z5thm8g9h,
  StreamMessageBinary as StreamMessageBinary21ruu70xkf9uf,
  StreamMessageString as StreamMessageString39p72u9yibcdc,
  StreamMessage as StreamMessage1e9va7cm3qf8q,
  KrpcConnector as KrpcConnectorsn3f9h83qubb,
  sendCancellation as sendCancellation2qvnp88e4j4hc,
  KrpcEndpoint as KrpcEndpoint1s5gofkbk9zxj,
  Failure_0 as Failure2wqvlrjpa8l54,
  Handshake as Handshakes7sujajuvjgm,
  StreamSerializer as StreamSerializer1zsx0m41iechn,
  buildContextual as buildContextual34zooulbn4ib4,
  cancellationType as cancellationType2thefpqbdfadt,
  decodeMessageData as decodeMessageDatad5q5piqbwv7j,
  deserialize as deserialize15kk7mfgp3ocj,
  rpcInternalObjectId as rpcInternalObjectId1j81fi2yp6iv3,
  serializeException as serializeException2dx7mm3wofz2y,
  unsupportedSerialFormatError as unsupportedSerialFormatError2csqaxsmaf5vz,
  Client as Client11cfsk9efm91u,
  BinaryMessage as BinaryMessage1vcfklwl6l2fk,
  StringMessage as StringMessage2xq2dimbrolxk,
  rpcClientConfig as rpcClientConfigy5q3ofzedgjx,
};
//endregion
